package com.yendo.mx.ui.orders

import androidx.compose.animation.*
import androidx.compose.animation.core.*
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.Send
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import androidx.compose.material3.pulltorefresh.PullToRefreshBox
import androidx.compose.material3.pulltorefresh.rememberPullToRefreshState
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.draw.clip
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.platform.LocalSoftwareKeyboardController
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import com.yendo.mx.utils.BackHandler
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.platform.LocalHapticFeedback
import androidx.compose.ui.hapticfeedback.HapticFeedbackType
import coil3.compose.AsyncImage
import androidx.compose.ui.layout.ContentScale
import com.yendo.mx.utils.rememberYendoImagePickerLauncher
import kotlinx.coroutines.flow.catch
import com.yendo.mx.ui.theme.RosaYendo
import com.yendo.mx.ui.profile.TarjetaGuardada
import com.yendo.mx.models.PedidoFirebase
import com.yendo.mx.models.CartItemFirebase
import androidx.compose.ui.unit.Dp
import com.yendo.mx.models.PedidosManager
import com.yendo.mx.utils.getAhora
import com.yendo.mx.utils.formatPrecio
import com.yendo.mx.utils.formatoHora
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import dev.gitlive.firebase.database.database
import dev.gitlive.firebase.firestore.FieldPath
import kotlinx.coroutines.launch
import kotlinx.coroutines.delay
import kotlinx.datetime.*
import androidx.compose.ui.input.nestedscroll.NestedScrollConnection
import androidx.compose.ui.input.nestedscroll.NestedScrollSource
import androidx.compose.ui.input.nestedscroll.nestedScroll
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.input.pointer.PointerEventPass
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.*
import kotlin.math.*

// 🚀 IMPORTS PARA LOTTIE
import org.jetbrains.compose.resources.ExperimentalResourceApi
import yendo.shared.generated.resources.*
import io.github.alexzhirkevich.compottie.Compottie
import io.github.alexzhirkevich.compottie.LottieCompositionSpec
import io.github.alexzhirkevich.compottie.rememberLottieComposition
import io.github.alexzhirkevich.compottie.rememberLottiePainter
import androidx.compose.foundation.Image

@Serializable
data class MensajeFirebase(
    val id: String = "",
    val texto: String = "",
    val emisorId: String = "",
    val timestamp: Long = 0L,
    val estado: String = "ENVIADO"
)

@Serializable
data class UbicacionGPS(
    val latitude: Double? = null,
    val longitude: Double? = null,
    val ultima_actualizacion_gps: Long? = null // 🚀 EL CAMPO QUE CAUSABA EL CRASH
)

@OptIn(ExperimentalMaterial3Api::class, ExperimentalResourceApi::class)
@Composable
fun PedidoActivoScreen(
    idPedido: String,
    onBack: () -> Unit
) {
    val isDark = isSystemInDarkTheme()
    val colorFondoBase = if (isDark) Color(0xFF121212) else Color(0xFFF5F5F5)
    val colorSuperficie = if (isDark) Color(0xFF1E1E1E) else Color.White
    val colorTextoPrimario = if (isDark) Color.White else Color.Black
    val colorTextoSecundario = if (isDark) Color(0xFFAAAAAA) else Color.Gray
    val colorDivisor = if (isDark) Color(0xFF2C2C2E) else Color(0xFFF8F8F8)
    val colorBotonAyuda = if (isDark) Color(0xFF333333) else Color(0xFFF5F5F5)
    val colorCanceladoFondo = if (isDark) Color(0xFF3E1212) else Color(0xFFFFEBEE)

    val scope = rememberCoroutineScope()
    val haptic = LocalHapticFeedback.current
    val uriHandler = LocalUriHandler.current
    val clipboardManager = LocalClipboardManager.current
    
    val pedidoState = remember { mutableStateOf<PedidoFirebase?>(null) }
    val pedido = pedidoState.value
    var isLoading by remember { mutableStateOf(true) }

    var mostrarDialogoCancelar by remember { mutableStateOf(false) }
    var mostrarChat by remember { mutableStateOf(false) }
    var subiendoComprobante by remember { mutableStateOf(false) }
    var errorSubida by remember { mutableStateOf<String?>(null) }
    var mapaExpandido by remember { mutableStateOf(false) }
    var esModoSatelite by remember { mutableStateOf(false) }
    var datosBancarios by remember { mutableStateOf<Map<String, String>?>(null) }

    // 🚀 ESTADO PARA VALIDACIÓN DE AJUSTES
    var mostrarDetallesCambios by remember { mutableStateOf(false) }
    var mostrarDialogoCVVAjuste by remember { mutableStateOf(false) }
    var cvvAjusteInput by remember { mutableStateOf("") }
    var errorCVVAjuste by remember { mutableStateOf<String?>(null) }
    var procesandoAjusteSincrono by remember { mutableStateOf(false) }

    // 🚀 ESTADO PARA RASTREO EN VIVO
    var latRepartidor by remember { mutableStateOf<Double?>(null) }
    var lngRepartidor by remember { mutableStateOf<Double?>(null) }
    
    // 🚀 VARIABLE PARA ALTERNAR LOTTIES EN BUSQUEDA
    var alternarLottie by remember { mutableStateOf(false) }

    val mensajes = remember(idPedido) { mutableStateListOf<MensajeFirebase>() }

    // 🚀 CICLO DE INTERCAMBIO DE LOTTIE (Solo en búsqueda)
    LaunchedEffect(pedido?.estadoActual) {
        if (pedido?.estadoActual == "BUSCANDO_REPARTIDOR") {
            while (true) {
                kotlinx.coroutines.delay(4000)
                alternarLottie = !alternarLottie
            }
        } else {
            alternarLottie = false
        }
    }

    // 🚀 ESCUCHA REACTIVA EXCLUSIVA VÍA REALTIME DATABASE (RTDB)
    LaunchedEffect(pedido?.idRepartidor, pedido?.idZona) {
        val idRep = pedido?.idRepartidor
        val idZonaReq = pedido?.idZona?.ifBlank { null } ?: "arriaga"

        if (!idRep.isNullOrBlank()) {
            try {
                val rtdbRef = dev.gitlive.firebase.Firebase.database.reference("ubicaciones_repartidores/$idZonaReq/$idRep")
                rtdbRef.valueEvents.collect { snap ->
                    if (snap.exists) {
                        val lat = try { snap.child("lat").value as? Double } catch(e: Exception) { null }
                        val lng = try { snap.child("lng").value as? Double } catch(e: Exception) { null }

                        if (lat != null && lng != null) {
                            latRepartidor = lat
                            lngRepartidor = lng
                            println("YENDO_LOG GPS RTDB: Moto en tiempo real: $lat, $lng")
                        }
                    }
                }
            } catch (e: Exception) {
                println("YENDO_LOG GPS RTDB ERROR: ${e.message}")
            }
        }
    }
    // 🚀 OBTENER DATOS BANCARIOS SI ES TRANSFERENCIA
    LaunchedEffect(pedido?.idRestaurante, pedido?.metodoPago, pedido?.tipoPedido) {
        if (pedido?.metodoPago?.uppercase() == "TRANSFERENCIA") {
            try {
                val esMandadito = pedido.tipoPedido.uppercase() == "MANDADITO"

                if (esMandadito) {
                    // 🚀 ENRUTAMIENTO YENDO MX: Lee la cuenta global de la empresa
                    val snapshot = Firebase.firestore.collection("Configuraciones").document("Globales").get()
                    if (snapshot.exists) {
                        // Usando los nombres reales de la BD
                        val banco = snapshot.get<String>("banco_maestro") ?: "MERCADO PAGO"
                        val beneficiario = snapshot.get<String>("beneficiario_maestro") ?: "YENDO MX"
                        val cuenta = snapshot.get<String>("clabe_maestra") ?: "000000000000000000"

                        datosBancarios = mapOf("banco" to banco, "beneficiario" to beneficiario, "cuenta" to cuenta)
                    }
                } else if (pedido.idRestaurante.isNotBlank()) {
                    // 🏪 ENRUTAMIENTO COMERCIO: Código original para restaurantes
                    val snapshot = Firebase.firestore.collection("Negocios").document(pedido.idRestaurante).get()
                    if (snapshot.exists) {
                        val banco = snapshot.get<String>("finanzas_locales.datos_bancarios.banco") ?: ""
                        val beneficiario = snapshot.get<String>("finanzas_locales.datos_bancarios.beneficiario") ?: ""
                        val cuenta = snapshot.get<String>("finanzas_locales.datos_bancarios.cuenta") ?: ""
                        datosBancarios = mapOf("banco" to banco, "beneficiario" to beneficiario, "cuenta" to cuenta)
                    }
                }
            } catch (e: Exception) {
                println("YENDO_LOG FINANZAS: Error obteniendo cuenta bancaria -> ${e.message}")
            }
        }
    }

    LaunchedEffect(idPedido) {
        if (idPedido.isNotBlank()) {
            println("YENDO_LOG TRACKING: Empezando escucha de pedido $idPedido")
            Firebase.firestore.collection("Pedidos").document(idPedido)
                .snapshots.catch { }.collect { snapshot ->
                    println("YENDO_LOG TRACKING: Snapshot recibido. Exists: ${snapshot.exists}")
                    if (snapshot.exists) {
                        try {
                            val ped = snapshot.data<PedidoFirebase>()
                            pedidoState.value = ped
                            println("YENDO_LOG TRACKING: Model PedidoFirebase mapeado con éxito. Estado: ${ped.estadoActual}")
                        } catch (e: Exception) {
                            println("YENDO_LOG TRACKING: ERROR FATAL MAPEANDO MODELO -> ${e.message}")
                            e.printStackTrace()
                        }
                    }
                    isLoading = false
                }
        }
    }

    LaunchedEffect(idPedido) {
        if (idPedido.isBlank()) return@LaunchedEffect
        try {
            Firebase.firestore.collection("Pedidos").document(idPedido).collection("Mensajes")
                .snapshots.catch { }.collect { snapshot ->
                    val msgs = snapshot.documents.mapNotNull { doc ->
                        try {
                            val msg = doc.data<MensajeFirebase>()
                            msg.copy(id = doc.id)
                        } catch (e: Exception) { null }
                    }.sortedBy { it.timestamp }
                    mensajes.clear()
                    mensajes.addAll(msgs)
                }
        } catch (e: Exception) {}
    }

    LaunchedEffect(mensajes.size, mostrarChat, idPedido) {
        if (idPedido.isBlank()) return@LaunchedEffect
        mensajes.toList().forEach { msg ->
            if (msg.emisorId != "cliente") {
                try {
                    val dbRef = Firebase.firestore.collection("Pedidos").document(idPedido).collection("Mensajes").document(msg.id)
                    if (msg.estado == "ENVIADO" && !mostrarChat) {
                        dbRef.update("estado" to "ENTREGADO")
                    } else if (msg.estado != "VISTO" && mostrarChat) {
                        dbRef.update("estado" to "VISTO")
                    }
                } catch (e: Exception) {}
            }
        }
    }

    LaunchedEffect(pedido?.estadoActual) {
        if (pedido?.estadoActual == "EN_PUERTA") {
            haptic.performHapticFeedback(HapticFeedbackType.LongPress)
        }
    }

    LaunchedEffect(pedido?.estadoActual) {
        if (pedido?.estadoActual == "CONCLUIDO") {
            onBack()
        }
    }

    val imagePicker = rememberYendoImagePickerLauncher(
        onResult = { byteArrays ->
            val imageBytes = byteArrays.firstOrNull()
            if (imageBytes != null) {
                subiendoComprobante = true
                errorSubida = null
                scope.launch {
                    try {
                        val url = PedidosManager.subirComprobantePago(idPedido, imageBytes)
                        if (url != null) {
                            Firebase.firestore.collection("Pedidos").document(idPedido)
                                .update("estadoActual" to "REVISANDO_COMPROBANTE", "urlComprobante" to url)
                        } else {
                            errorSubida = "No se pudo subir la imagen. Intenta de nuevo."
                        }
                    } catch (e: Exception) {
                        errorSubida = "Error de red o conexión. Revisa tu internet."
                    } finally {
                        subiendoComprobante = false
                    }
                }
            }
        }
    )

    BackHandler { onBack() }

    Surface(modifier = Modifier.fillMaxSize(), color = colorFondoBase) {
        if (isLoading) {
            Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                CircularProgressIndicator(color = RosaYendo)
            }
        } else if (pedido == null) {
            println("YENDO_LOG TRACKING: Pedido es NULL tras carga")
            Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                Text("No se encontró el pedido", color = colorTextoPrimario)
            }
        } else {
            println("YENDO_LOG TRACKING: Iniciando composición de UI principal")
            val esPickupReal = pedido.tipoPedido.uppercase() == "PICKUP"
            val esCancelado = pedido.estadoActual == "CANCELADO"
            val esComercio = pedido.pagoPostArmado
            val esMandadito = pedido.tipoPedido.uppercase() == "MANDADITO"

            println("YENDO_LOG TRACKING: Datos base -> Pickup: $esPickupReal, Cancelado: $esCancelado, Comercio: $esComercio, Mandadito: $esMandadito")

            val (tituloEstado, subTituloEstado) = when (pedido.estadoActual) {
                    "ESPERANDO_COMPROBANTE" -> "Pago Pendiente" to "Adjunta tu comprobante de transferencia."
                    "REVISANDO_COMPROBANTE" -> "Verificando Pago" to "El comercio está revisando tu comprobante."
                    "REINTENTAR_PAGO" -> "Pago no Válido" to "El comprobante fue rechazado. Intenta de nuevo."
                    "VALIDACION" -> "Validando Pago" to "Verificando transferencia en el banco."
                    "VALIDACION_CLIENTE" -> "Ajuste de Pedido" to "Revisa los cambios para continuar."
                    "PROGRAMADO" -> {
                        if (pedido.aceptadoPorComercio == true) {
                            "Pedido Confirmado" to "Listo para cocinar a la hora programada (${pedido.tiempo_estimado_cocina.toInt()} min de prep.)"
                        } else {
                            "Pendiente de confirmación" to "Esperando que el comercio acepte tu orden programada."
                        }
                    }
                    "SOLICITUD" -> {
                        if (esMandadito) "Procesando envío..." to "Buscando al repartidor ideal."
                        else "Enviando pedido..." to "Esperando que el comercio acepte tu orden."
                    }
                    "ARMANDO_PEDIDO", "PREPARANDO" -> {
                        if (esMandadito) "Procesando envío" to "Asignando unidad."
                        else if (pedido.estadoActual == "ARMANDO_PEDIDO") "Armando tu pedido" to "Seleccionando y pesando tus productos."
                        else "Preparando tu comida" to "Cocinando tus platillos."
                    }
                    "LISTO" -> {
                        if (esMandadito) "Paquete listo" to "Esperando recolección."
                        else if (esPickupReal) "¡Listo para Recoger!" to "Pasa al mostrador."
                        else "Pedido Armado" to "Empacado esperando al repartidor."
                    }
                    "LISTO_RECOGER" -> "¡Listo para Recoger!" to "Tu pedido te espera en el mostrador."
                    "BUSCANDO_REPARTIDOR" -> {
                        if (esMandadito) "Asignando Repartidor" to "Conectando con un conductor cercano."
                        else "Preparando y Asignando" to "¡Tu pedido casi está listo! Buscando repartidor para recolección inmediata."
                    }
                    "ACEPTADO_POR_REPARTIDOR" -> {
                        if (esMandadito) "Repartidor asignado" to "Va al punto de recolección."
                        else "Repartidor en camino" to "Va por tu pedido mientras terminan de ${if(esComercio) "empacarlo" else "cocinarlo"}."
                    }
                    "RECOLECTANDO" -> {
                        if (esMandadito) "Recolectando paquete" to "El repartidor está recogiendo tu envío."
                        else "Repartidor en sucursal" to "Verificando tus productos."
                    }
                    "EN_CAMINO" -> {
                        if (esMandadito) "Paquete YENDO 📦" to "Síguelo en el mapa."
                        else "Pedido YENDO" to "Síguelo en el mapa."
                    }
                    "EN_PUERTA" -> {
                        if (esMandadito) "¡Repartidor Afuera! 🔔" to "Sal a recibir tu paquete."
                        else "¡Repartidor Afuera!" to "Ha llegado al domicilio. ¡Baja a recibirlo!"
                    }
                    "ENTREGADO" -> "¡Pedido Entregado!" to "Califica tu experiencia."
                    "PROCESANDO_AJUSTE" -> "Procesando Pago 💳" to "Validando el saldo final de tu pedido con el banco."
                    "ERROR_COBRO_AJUSTE", "ERROR_COBRO_EXTRA" -> "Fallo en Cobro con Tarjeta ⚠️" to "No se pudo autorizar el pago con tu tarjeta. Cambia de tarjeta o contacta a soporte."
                    "CANCELADO" -> "Pedido Cancelado" to "Esta orden fue anulada."
                    else -> "Sincronizando..." to "Actualizando datos."
                }
                println("YENDO_LOG TRACKING: Estado visual -> $tituloEstado")

                val progresoStepper = when (pedido.estadoActual) {
                    "PROGRAMADO", "SOLICITUD", "VALIDACION" -> 1
                    "ESPERANDO_COMPROBANTE", "REVISANDO_COMPROBANTE", "REINTENTAR_PAGO", "VALIDACION_CLIENTE", "PROCESANDO_AJUSTE" -> {
                        if (pedido.pagoPostArmado == true) 2 else 1
                    }
                    "ARMANDO_PEDIDO", "PREPARANDO" -> {
                        if (pedido.pagoPostArmado == true) 1 else 2
                    }
                    "LISTO", "LISTO_RECOGER" -> 2
                    "BUSCANDO_REPARTIDOR", "ACEPTADO_POR_REPARTIDOR", "RECOLECTANDO" -> 3
                    "EN_CAMINO", "EN_PUERTA" -> 4
                    "ENTREGADO", "CONCLUIDO" -> 5
                    else -> 0
                }
                println("YENDO_LOG TRACKING: Stepper -> $progresoStepper")

                val puedeChat = pedido.estadoActual in listOf(
                    "ESPERANDO_COMPROBANTE", "REVISANDO_COMPROBANTE", "REINTENTAR_PAGO", "VALIDACION_CLIENTE",
                    "SOLICITUD", "PREPARANDO", "ARMANDO_PEDIDO", "LISTO", "LISTO_RECOGER",
                    "BUSCANDO_REPARTIDOR", "ACEPTADO_POR_REPARTIDOR", "RECOLECTANDO",
                    "EN_CAMINO", "EN_PUERTA"
                )

                val puedeCancelar = pedido.estadoActual in listOf(
                    "ESPERANDO_COMPROBANTE", "REVISANDO_COMPROBANTE", "REINTENTAR_PAGO", "VALIDACION", "PROGRAMADO", "SOLICITUD"
                )

                val totalRealActualizado = pedido.desgloseCliente.totalPagadoFinal
                    ?: pedido.desgloseCliente.totalPagadoFinalSnake
                    ?: pedido.totalPagadoFinal
                    ?: pedido.totalPagadoFinalSnake
                    ?: pedido.desgloseCliente.totalPagado

                val montoMuestra = if (esComercio && pedido.estadoActual in listOf("SOLICITUD", "ARMANDO_PEDIDO", "PREPARANDO")) {
                    "$${formatPrecio(totalRealActualizado)} (Aprox)"
                } else {
                    "$${formatPrecio(totalRealActualizado)}"
                }

                val contactoActivo = if (pedido.estadoActual in listOf("EN_CAMINO", "EN_PUERTA") && !esPickupReal) "repartidor" else "restaurante"
            val nombreContacto = if (contactoActivo == "repartidor") {
                pedido.datosRepartidor?.get("nombre") ?: "Juan (Repartidor)"
            } else {
                "${pedido.nombreRestaurante} (Negocio)"
            }
            val fotoContacto = if (contactoActivo == "repartidor") {
                pedido.datosRepartidor?.get("foto_perfil")
            } else {
                pedido.logoRestaurante.ifBlank { null }
            }
            val iconoContacto = if (contactoActivo == "repartidor") Icons.Default.Motorcycle else Icons.Default.Storefront

            if (pedido.estadoActual == "ENTREGADO") {
                val aplicaRepartidor = pedido.tipoPedido.uppercase() == "DELIVERY" && !pedido.idRepartidor.isNullOrBlank()

                CalificarPedidoScreen(
                    nombreRestaurante = pedido.nombreRestaurante,
                    logoRestaurante = pedido.logoRestaurante.ifBlank { null },
                    datosRepartidor = pedido.datosRepartidor,
                    aplicaRepartidor = aplicaRepartidor,
                    listaProductos = pedido.productos.ifEmpty { pedido.productosSolicitados },
                    onEnviarCalificacion = { starsRest, commentRest, starsRep, commentRep ->
                        scope.launch {
                            try {
                                Firebase.firestore.collection("Pedidos").document(pedido.idPedido)
                                    .update(
                                        "estadoActual" to "CONCLUIDO",
                                        "tiempos.concluido" to getAhora(),
                                        "estrellasRestaurante" to starsRest.toLong(),
                                        "comentarioRestaurante" to commentRest,
                                        "estrellasRepartidor" to starsRep?.toLong(),
                                        "comentarioRepartidor" to commentRep
                                    )
                            } catch (e: Exception) {
                                println("YENDO_LOG ERROR: Fallo al guardar calificación -> ${e.message}")
                            }
                        }
                    }
                )
            } else {
                Scaffold(
                    bottomBar = {
                        if (puedeChat && !esCancelado) {
                            Surface(shadowElevation = 16.dp, color = colorSuperficie) {
                                Column(modifier = Modifier.padding(16.dp).navigationBarsPadding()) {
                                    Button(
                                        onClick = { mostrarChat = true },
                                        modifier = Modifier.fillMaxWidth().height(50.dp),
                                        colors = ButtonDefaults.buttonColors(colorBotonAyuda),
                                        shape = RoundedCornerShape(12.dp)
                                    ) {
                                        if (fotoContacto != null) {
                                            AsyncImage(
                                                model = fotoContacto,
                                                contentDescription = null,
                                                modifier = Modifier.size(24.dp).clip(CircleShape),
                                                contentScale = ContentScale.Crop
                                            )
                                        } else {
                                            Icon(Icons.Default.ChatBubbleOutline, null, tint = RosaYendo)
                                        }
                                        Spacer(Modifier.width(8.dp))
                                        Text("Mensaje a $nombreContacto", fontWeight = FontWeight.Bold, color = RosaYendo, maxLines = 1)
                                    }
                                }
                            }
                        }
                    },
                    containerColor = colorFondoBase
                ) { padding ->
                    val pullRefreshState = rememberPullToRefreshState()
                    var isRefreshing by remember { mutableStateOf(false) }
                    var isMapInteracting by remember { mutableStateOf(false) }

                    PullToRefreshBox(
                        isRefreshing = isRefreshing,
                        onRefresh = {
                            if (!isMapInteracting) {
                                scope.launch {
                                    isRefreshing = true
                                    try {
                                        // 🚀 FORZAMOS UNA LECTURA FRESCA DEL PEDIDO
                                        val snapshot = Firebase.firestore.collection("Pedidos").document(idPedido).get()
                                        if (snapshot.exists) {
                                            pedidoState.value = snapshot.data<PedidoFirebase>()
                                        }
                                    } catch (e: Exception) {
                                        println("YENDO_LOG ERROR: Fallo al refrescar pedido -> ${e.message}")
                                    }
                                    delay(800)
                                    isRefreshing = false
                                }
                            }
                        },
                        state = pullRefreshState,
                        modifier = Modifier.fillMaxSize()
                    ) {
                        Box(modifier = Modifier.fillMaxSize()) {
                            Column(
                                modifier = Modifier
                                    .fillMaxSize()
                                    .padding(bottom = padding.calculateBottomPadding())
                                    .verticalScroll(rememberScrollState(), enabled = !isMapInteracting)
                            ) {
                        
                        val lottiePath = when (pedido.estadoActual) {
                            "ESPERANDO_COMPROBANTE" -> "files/validando_pago.json"
                            "REVISANDO_COMPROBANTE" -> "files/revisando_comprobante.json"
                            "REINTENTAR_PAGO", "ERROR_COBRO_AJUSTE", "ERROR_COBRO_EXTRA" -> "files/error.json"
                            "PROCESANDO_AJUSTE" -> "files/validando_pago.json"
                            "VALIDACION" -> "files/validando_pago.json"
                            "VALIDACION_CLIENTE" -> "files/validacion_cliente.json"
                            "SOLICITUD" -> "files/solicitud.json"
                            "PROGRAMADO" -> "files/programado.json"
                            "ARMANDO_PEDIDO" -> "files/armando_pedido.json"
                            "PREPARANDO" -> "files/preparando.json"
                            "LISTO" -> "files/listo.json"
                            "LISTO_RECOGER" -> "files/listo_recoger.json"
                            "BUSCANDO_REPARTIDOR" -> {
                                if (esMandadito) "files/buscando_repartidor.json" // 📡 Radar para envíos
                                else {
                                    // 🚀 ALTERNANCIA DINÁMICA
                                    if (alternarLottie) {
                                        if (esComercio) "files/armando_pedido.json"
                                        else "files/preparando.json"
                                    } else {
                                        "files/buscando_repartidor.json"
                                    }
                                }
                            }
                            "ACEPTADO_POR_REPARTIDOR", "RECOLECTANDO" -> {
                                if (esMandadito) "files/recolectando.json"
                                else {
                                    if (alternarLottie) {
                                        if (esComercio) "files/armando_pedido.json"
                                        else "files/preparando.json"
                                    } else {
                                        "files/recolectando.json"
                                    }
                                }
                            }
                            "EN_CAMINO" -> {
                                if (esMandadito) "files/envio_en_camino.json" // 📦 Paquete en ruta
                                else if (esComercio) "files/comercio_en_camino.json"
                                else "files/restaurante_en_camino.json"
                            }
                            "EN_PUERTA" -> "files/en_puerta.json"
                            else -> null
                        }

                        val mostrarMapaAhora = pedido.estadoActual !in listOf(
                            "ESPERANDO_COMPROBANTE", "REVISANDO_COMPROBANTE", "REINTENTAR_PAGO", 
                            "VALIDACION", "VALIDACION_CLIENTE", "ERROR_COBRO_AJUSTE", "ERROR_COBRO_EXTRA"
                        )

                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(
                                    if (mapaExpandido) 550.dp 
                                    else if (!mostrarMapaAhora) 380.dp // 🚀 Altura optimizada para que el estado sea visible sin scroll
                                    else 320.dp // 🚀 MAPA COMPACTO AHORA MÁS GRANDE
                                )
                                .animateContentSize()
                                .pointerInput(Unit) {
                                    awaitPointerEventScope {
                                        while (true) {
                                            val event = awaitPointerEvent(PointerEventPass.Initial)
                                            isMapInteracting = event.changes.any { it.pressed }
                                        }
                                    }
                                }
                        ) {

                            if (!esCancelado && mostrarMapaAhora) {
                                com.yendo.mx.ui.components.MapaYendo(
                                    modifier = Modifier.fillMaxSize(),
                                    latNegocio = pedido.ubicacionNegocio.latitude,
                                    lngNegocio = pedido.ubicacionNegocio.longitude,
                                    latEntrega = if (esPickupReal) null else pedido.ubicacionEntrega.latitude,
                                    lngEntrega = if (esPickupReal) null else pedido.ubicacionEntrega.longitude,
                                    nombreNegocio = pedido.nombreRestaurante,
                                    latRepartidor = latRepartidor,
                                    lngRepartidor = lngRepartidor,
                                    esModoSatelite = esModoSatelite
                                )

                                Column(
                                    modifier = Modifier
                                        .align(Alignment.TopEnd)
                                        .statusBarsPadding()
                                        .padding(16.dp),
                                    verticalArrangement = Arrangement.spacedBy(8.dp),
                                    horizontalAlignment = Alignment.End
                                ) {
                                    // Botón para Expandir/Contraer Mapa
                                    FilledTonalIconButton(
                                        onClick = { mapaExpandido = !mapaExpandido },
                                        colors = IconButtonDefaults.filledTonalIconButtonColors(
                                            containerColor = colorSuperficie.copy(alpha = 0.85f)
                                        )
                                    ) {
                                        Icon(
                                            if (mapaExpandido) Icons.Default.FullscreenExit else Icons.Default.Fullscreen,
                                            contentDescription = "Expandir Mapa",
                                            tint = RosaYendo
                                        )
                                    }

                                    // 🚀 BOTÓN ABAJO DE EXPANDIR MAPA PARA ALTERNAR EN VISTA SATELITAL
                                    FilledTonalIconButton(
                                        onClick = { esModoSatelite = !esModoSatelite },
                                        colors = IconButtonDefaults.filledTonalIconButtonColors(
                                            containerColor = if (esModoSatelite) RosaYendo else colorSuperficie.copy(alpha = 0.85f)
                                        )
                                    ) {
                                        Icon(
                                            imageVector = Icons.Default.Layers,
                                            contentDescription = "Alternar Satélite",
                                            tint = if (esModoSatelite) Color.White else RosaYendo
                                        )
                                    }
                                }


                                // 🚀 BOTÓN "IR AL LOCAL" (Solo si es Pickup)
                                if (esPickupReal) {
                                    Button(
                                        onClick = {
                                            try {
                                                val uri = "https://www.google.com/maps/search/?api=1&query=${pedido.ubicacionNegocio.latitude},${pedido.ubicacionNegocio.longitude}"
                                                uriHandler.openUri(uri)
                                            } catch (e: Exception) {}
                                        },
                                        modifier = Modifier
                                            .align(Alignment.BottomStart)
                                            .padding(start = 16.dp, bottom = 46.dp), // Arriba de la tarjeta de estado
                                        colors = ButtonDefaults.buttonColors(containerColor = Color.White),
                                        contentPadding = PaddingValues(horizontal = 12.dp, vertical = 8.dp),
                                        shape = RoundedCornerShape(12.dp),
                                        elevation = ButtonDefaults.buttonElevation(4.dp)
                                    ) {
                                        Icon(Icons.Default.Directions, null, tint = Color(0xFF2196F3), modifier = Modifier.size(18.dp))
                                        Spacer(Modifier.width(8.dp))
                                        Text("Ir al local", color = Color(0xFF2196F3), fontWeight = FontWeight.Bold, fontSize = 12.sp)
                                    }
                                }
                            } else if (!esCancelado && !mostrarMapaAhora) {
                                // 🏦 VISTA DE REEMPLAZO (Sustituye al Mapa)
                                Column(
                                    modifier = Modifier
                                        .fillMaxSize()
                                        .background(colorFondoBase)
                                        .statusBarsPadding()
                                        .padding(top = 64.dp) // 🚀 Un poco más arriba para ganar espacio
                                        .padding(horizontal = 24.dp),
                                    horizontalAlignment = Alignment.CenterHorizontally,
                                    verticalArrangement = Arrangement.Top
                                ) {
                                    if (pedido.estadoActual == "VALIDACION_CLIENTE") {
                                        // 🚀 VISTA DE VALIDACIÓN DE PESOS
                                        val totalOriginalEstimado = pedido.desgloseCliente.totalPagado
                                        val totalNuevoAjustado = pedido.desgloseCliente.totalPagadoFinal 
                                            ?: pedido.desgloseCliente.totalPagadoFinalSnake
                                            ?: pedido.totalPagadoFinal
                                            ?: pedido.totalPagadoFinalSnake
                                            ?: totalOriginalEstimado

                                        val diferencia = totalNuevoAjustado - totalOriginalEstimado
                                        val esTarjeta = pedido.metodoPago.uppercase() == "TARJETA"

                                        Surface(
                                            color = colorSuperficie,
                                            shape = RoundedCornerShape(12.dp),
                                            border = BorderStroke(1.dp, Color(0xFFFFCC80)),
                                            modifier = Modifier.fillMaxWidth()
                                        ) {
                                            Column(modifier = Modifier.padding(16.dp)) {
                                                Row(verticalAlignment = Alignment.CenterVertically) {
                                                    Icon(Icons.Default.Scale, contentDescription = null, tint = Color(0xFFFF9800), modifier = Modifier.size(20.dp))
                                                    Spacer(Modifier.width(12.dp))
                                                    Text("Ajuste de pesos reales", fontWeight = FontWeight.ExtraBold, fontSize = 14.sp, color = Color(0xFFE65100))
                                                }
                                                
                                                Spacer(Modifier.height(16.dp))
                                                
                                                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                                                    Column {
                                                        Text("Estimado Original", color = colorTextoSecundario, fontSize = 10.sp)
                                                        Text("$${formatPrecio(totalOriginalEstimado)}", color = colorTextoSecundario, textDecoration = androidx.compose.ui.text.style.TextDecoration.LineThrough, fontSize = 14.sp, fontWeight = FontWeight.Bold)
                                                    }
                                                    Column(horizontalAlignment = Alignment.End) {
                                                        Text("Nuevo Total", fontWeight = FontWeight.Bold, fontSize = 10.sp, color = RosaYendo)
                                                        Text("$${formatPrecio(totalNuevoAjustado)}", fontWeight = FontWeight.Black, fontSize = 22.sp, color = RosaYendo)
                                                    }
                                                }

                                                Spacer(Modifier.height(8.dp))
                                                HorizontalDivider(color = colorDivisor.copy(alpha = 0.5f))
                                                Spacer(Modifier.height(8.dp))

                                                TextButton(
                                                    onClick = { mostrarDetallesCambios = true },
                                                    modifier = Modifier.fillMaxWidth(),
                                                    contentPadding = PaddingValues(0.dp)
                                                ) {
                                                    Text("Ver detalle de productos modificados", fontSize = 11.sp, fontWeight = FontWeight.Bold, color = Color(0xFFE65100))
                                                }
                                            }
                                        }

                                        Spacer(Modifier.height(16.dp))

                                        Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                                            OutlinedButton(
                                                onClick = { mostrarDialogoCancelar = true },
                                                modifier = Modifier.weight(1f).height(48.dp),
                                                shape = RoundedCornerShape(12.dp),
                                                border = BorderStroke(1.dp, Color.Red),
                                                colors = ButtonDefaults.outlinedButtonColors(contentColor = Color.Red)
                                            ) {
                                                Text("Cancelar", fontWeight = FontWeight.Bold, fontSize = 13.sp)
                                            }
                                            
                                            Button(
                                                onClick = {
                                                    val mPago = pedido.metodoPago.uppercase()
                                                    when {
                                                        mPago == "EFECTIVO" || mPago == "CASH" -> {
                                                            // 🚀 CARRIL EFECTIVO: Avance directo con prioridad a PICKUP
                                                            val esProg = pedido.esProgramado
                                                            val ppa = pedido.pagoPostArmado
                                                            val siguienteEstado = if (esPickupReal) {
                                                                "LISTO_RECOGER"
                                                            } else if (esProg) {
                                                                if (ppa) "ARMANDO_PEDIDO" else "PREPARANDO"
                                                            } else {
                                                                "BUSCANDO_REPARTIDOR"
                                                            }
                                                            
                                                            val updates = mutableMapOf<String, Any?>(
                                                                "estadoActual" to siguienteEstado
                                                            )
                                                            if (esProg) {
                                                                updates["surtidoConcluido"] = true
                                                            }

                                                            scope.launch {
                                                                try {
                                                                    Firebase.firestore.collection("Pedidos").document(pedido.idPedido)
                                                                        .update(updates.filterValues { it != null } as Map<String, Any>)
                                                                } catch (e: Exception) {}
                                                            }
                                                        }
                                                        mPago == "TRANSFERENCIA" || mPago == "SPEI" -> {
                                                            // 🚀 CARRIL TRANSFERENCIA: Esperar comprobante del ajuste
                                                            scope.launch {
                                                                try {
                                                                    Firebase.firestore.collection("Pedidos").document(pedido.idPedido)
                                                                        .update("estadoActual" to "ESPERANDO_COMPROBANTE")
                                                                } catch (e: Exception) {}
                                                            }
                                                        }
                                                        else -> {
                                                            // 🚀 CARRIL TARJETA: FinTech Hold & Capture
                                                            if (diferencia > 0) {
                                                                mostrarDialogoCVVAjuste = true
                                                            } else {
                                                                scope.launch {
                                                                    try {
                                                                        // 🚀 Marcamos estado visual bloqueante
                                                                        Firebase.firestore.collection("Pedidos").document(pedido.idPedido)
                                                                            .update("estadoActual" to "PROCESANDO_AJUSTE")
                                                                        
                                                                        // 🚀 Invocamos el cierre financiero síncrono
                                                                        val exitoAjuste = com.yendo.mx.repository.PagosRepository.procesarAjusteYCapturaFinal(
                                                                            idPedido = pedido.idPedido,
                                                                            nuevoTotal = totalNuevoAjustado
                                                                        )

                                                                        if (!exitoAjuste) {
                                                                            Firebase.firestore.collection("Pedidos").document(pedido.idPedido)
                                                                                .update(
                                                                                    "estadoActual" to "ERROR_COBRO_AJUSTE",
                                                                                    "motivoErrorExtra" to "Fallo en la captura de tarjeta"
                                                                                )
                                                                        }
                                                                    } catch (e: Exception) {
                                                                        Firebase.firestore.collection("Pedidos").document(pedido.idPedido)
                                                                            .update(
                                                                                "estadoActual" to "ERROR_COBRO_AJUSTE",
                                                                                "motivoErrorExtra" to (e.message ?: "Error al capturar pago")
                                                                            )
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                },
                                                modifier = Modifier.weight(1.5f).height(48.dp),
                                                shape = RoundedCornerShape(12.dp),
                                                colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF00C853)) // Verde
                                            ) {
                                                val mPago = pedido.metodoPago.uppercase()
                                                val textoBoton = when {
                                                    mPago == "EFECTIVO" || mPago == "CASH" -> "Aprobar Cambios"
                                                    mPago == "TRANSFERENCIA" || mPago == "SPEI" -> "Aprobar y Transferir"
                                                    diferencia > 0 -> "Autorizar $${formatPrecio(diferencia)}"
                                                    else -> "Aprobar Cambios"
                                                }
                                                Text(textoBoton, fontWeight = FontWeight.ExtraBold, fontSize = 13.sp)
                                            }
                                        }
                                    } else {
                                        // 🏦 VISTA DE DATOS BANCARIOS
                                        Surface(
                                            color = colorSuperficie,
                                            shape = RoundedCornerShape(12.dp),
                                            border = BorderStroke(1.dp, colorDivisor),
                                            modifier = Modifier.fillMaxWidth()
                                        ) {
                                            Column(modifier = Modifier.padding(12.dp)) {
                                                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                                                    Column(modifier = Modifier.weight(1f)) {
                                                        Text("Banco:", fontSize = 9.sp, color = colorTextoSecundario)
                                                        Text(datosBancarios?.get("banco") ?: "Cargando...", fontWeight = FontWeight.Bold, fontSize = 12.sp, color = colorTextoPrimario)
                                                    }
                                                    Column(modifier = Modifier.weight(1f), horizontalAlignment = Alignment.End) {
                                                        Text("Beneficiario:", fontSize = 9.sp, color = colorTextoSecundario)
                                                        Text(datosBancarios?.get("beneficiario") ?: pedido.nombreRestaurante, fontWeight = FontWeight.Bold, fontSize = 12.sp, color = colorTextoPrimario, textAlign = TextAlign.End, maxLines = 1)
                                                    }
                                                }
                                                
                                                Spacer(Modifier.height(8.dp))
                                                
                                                Row(
                                                    modifier = Modifier.fillMaxWidth().background(colorFondoBase.copy(alpha = 0.5f), RoundedCornerShape(8.dp)).padding(8.dp),
                                                    horizontalArrangement = Arrangement.SpaceBetween,
                                                    verticalAlignment = Alignment.CenterVertically
                                                ) {
                                                    Column {
                                                        Text("Cuenta / CLABE:", fontSize = 9.sp, color = colorTextoSecundario)
                                                        Text(datosBancarios?.get("cuenta") ?: "Cargando...", fontWeight = FontWeight.Black, fontSize = 14.sp, color = RosaYendo)
                                                    }
                                                    IconButton(
                                                        onClick = {
                                                            datosBancarios?.get("cuenta")?.let {
                                                                clipboardManager.setText(AnnotatedString(it))
                                                                haptic.performHapticFeedback(HapticFeedbackType.LongPress)
                                                            }
                                                        },
                                                        modifier = Modifier.size(30.dp)
                                                    ) {
                                                        Icon(Icons.Default.ContentCopy, null, tint = colorTextoSecundario, modifier = Modifier.size(16.dp))
                                                    }
                                                }
                                                
                                                Spacer(Modifier.height(8.dp))
                                                HorizontalDivider(color = colorDivisor.copy(alpha = 0.5f))
                                                Spacer(Modifier.height(8.dp))
                                                
                                                Row(
                                                    modifier = Modifier.fillMaxWidth(),
                                                    horizontalArrangement = Arrangement.SpaceBetween,
                                                    verticalAlignment = Alignment.CenterVertically
                                                ) {
                                                    Text("Monto exacto:", fontSize = 10.sp, fontWeight = FontWeight.Bold, color = colorTextoSecundario)
                                                    val totalDepositoExacto = pedido.desgloseCliente.totalPagadoFinal
                                                        ?: pedido.desgloseCliente.totalPagadoFinalSnake
                                                        ?: pedido.totalPagadoFinal
                                                        ?: pedido.totalPagadoFinalSnake
                                                        ?: pedido.desgloseCliente.totalPagado
                                                    Text("$${formatPrecio(totalDepositoExacto)}", fontWeight = FontWeight.Black, fontSize = 16.sp, color = colorTextoPrimario)
                                                }
                                            }
                                        }

                                        if (pedido.estadoActual in listOf("ESPERANDO_COMPROBANTE", "REINTENTAR_PAGO", "ERROR_COBRO_AJUSTE", "ERROR_COBRO_EXTRA")) {
                                            Spacer(Modifier.height(12.dp))
                                            
                                            errorSubida?.let {
                                                Text(
                                                    text = "⚠️ $it",
                                                    color = Color.Red,
                                                    fontSize = 11.sp,
                                                    fontWeight = FontWeight.Bold,
                                                    modifier = Modifier.padding(bottom = 8.dp),
                                                    textAlign = TextAlign.Center
                                                )
                                            }

                                            if (pedido.estadoActual in listOf("ERROR_COBRO_AJUSTE", "ERROR_COBRO_EXTRA")) {
                                                Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                                    Button(
                                                        onClick = {
                                                            errorCVVAjuste = null
                                                            cvvAjusteInput = ""
                                                            mostrarDialogoCVVAjuste = true
                                                        },
                                                        colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFFF9800)),
                                                        modifier = Modifier.weight(1f).height(50.dp),
                                                        shape = RoundedCornerShape(12.dp)
                                                    ) {
                                                        Icon(Icons.Default.Refresh, contentDescription = null, tint = Color.White, modifier = Modifier.size(18.dp))
                                                        Spacer(Modifier.width(6.dp))
                                                        Text("Reintentar Pago", fontSize = 12.sp, fontWeight = FontWeight.Bold, color = Color.White)
                                                    }

                                                    OutlinedButton(
                                                        onClick = { imagePicker.launch() }, enabled = !subiendoComprobante,
                                                        border = BorderStroke(1.dp, RosaYendo),
                                                        shape = RoundedCornerShape(12.dp),
                                                        modifier = Modifier.weight(1f).height(50.dp)
                                                    ) {
                                                        if (subiendoComprobante) CircularProgressIndicator(color = RosaYendo, modifier = Modifier.size(20.dp))
                                                        else Text("Pagar por SPEI", fontSize = 12.sp, fontWeight = FontWeight.Bold, color = RosaYendo)
                                                    }
                                                }
                                            } else {
                                                Button(
                                                    onClick = { imagePicker.launch() }, enabled = !subiendoComprobante,
                                                    colors = ButtonDefaults.buttonColors(containerColor = RosaYendo), shape = RoundedCornerShape(12.dp),
                                                    modifier = Modifier.fillMaxWidth().height(50.dp)
                                                ) {
                                                    if (subiendoComprobante) CircularProgressIndicator(color = Color.White, modifier = Modifier.size(20.dp))
                                                    else { Icon(Icons.Default.CloudUpload, null); Spacer(Modifier.width(8.dp)); Text("Subir Comprobante", fontWeight = FontWeight.Bold) }
                                                }
                                            }
                                        }
                                    }
                                }
                            } else {
                                Box(modifier = Modifier.fillMaxSize().background(colorCanceladoFondo), contentAlignment = Alignment.Center) {
                                    Text("PEDIDO CANCELADO", color = Color.Red, fontWeight = FontWeight.Bold)
                                }
                            }
                        }

                        // 🚀 EL MÓDULO DE ESTADO (Fuera del Box para evitar recortes)
                        Surface(
                            modifier = Modifier
                                .fillMaxWidth()
                                .offset(y = (-30).dp)
                                .padding(horizontal = 24.dp),
                            shape = RoundedCornerShape(16.dp),
                            shadowElevation = 8.dp,
                            color = colorSuperficie
                        ) {
                            Box(modifier = Modifier.padding(20.dp)) {
                                // 🚀 LOGÍSTICA DE TIEMPO (Cálculo Avanzado con Haversine)
                                val tiempoCocina = pedido.tiempo_estimado_cocina.toInt()
                                println("YENDO_LOG TRACKING: Tiempo cocina: $tiempoCocina")
                                
                                val tiempoTotalMinutos = if (!esPickupReal) {
                                    println("YENDO_LOG TRACKING: Calculando ETA. Negocio: ${pedido.ubicacionNegocio.latitude},${pedido.ubicacionNegocio.longitude} | Entrega: ${pedido.ubicacionEntrega.latitude},${pedido.ubicacionEntrega.longitude}")
                                    calcularETA(
                                        pedido.ubicacionNegocio.latitude,
                                        pedido.ubicacionNegocio.longitude,
                                        pedido.ubicacionEntrega.latitude,
                                        pedido.ubicacionEntrega.longitude,
                                        tiempoCocina
                                    )
                                } else {
                                    tiempoCocina
                                }
                                println("YENDO_LOG TRACKING: Tiempo total (min): $tiempoTotalMinutos")

                                // 🚀 CONVERSIÓN A HORA EXACTA (Priorizando Programación)
                                val arrivalTimestamp = if (pedido.esProgramado && pedido.fechaProgramada != null) {
                                    pedido.fechaProgramada
                                } else {
                                    val baseTime = pedido.tiempos.preparando ?: pedido.tiempos.creado
                                    baseTime + (tiempoTotalMinutos.toLong() * 60000)
                                }
                                val horaLlegada = formatoHora(arrivalTimestamp)

                                val textoTiempo = when {
                                    pedido.estadoActual in listOf("PROGRAMADO", "PREPARANDO", "ARMANDO_PEDIDO") -> {
                                        if (pedido.esProgramado) {
                                            if (esPickupReal) "Pasa por él a las: $horaLlegada"
                                            else "Llegada programada: $horaLlegada"
                                        } else {
                                            if (esPickupReal) "Pasa a las: $horaLlegada"
                                            else "Llega a las: $horaLlegada"
                                        }
                                    }
                                    esPickupReal && pedido.estadoActual == "LISTO_RECOGER" -> "¡Listo!"
                                    !esPickupReal && pedido.estadoActual in listOf("EN_CAMINO", "BUSCANDO_REPARTIDOR", "RECOLECTANDO") -> {
                                        if (pedido.esProgramado) "Entrega programada: $horaLlegada"
                                        else "Entrega a las: $horaLlegada"
                                    }
                                    else -> null
                                }

                                // 🚀 HORA EN LA PARTE SUPERIOR (Como Overlay absoluto para no mover nada)
                                if (textoTiempo != null) {
                                    Text(
                                        text = textoTiempo,
                                        fontSize = 13.sp,
                                        fontWeight = FontWeight.Black,
                                        color = RosaYendo,
                                        modifier = Modifier.align(Alignment.TopCenter)
                                    )
                                }

                                Column(
                                    modifier = Modifier.padding(top = 22.dp), // 🚀 ESPACIO RESERVADO: Evita que el Lottie salte
                                    horizontalAlignment = Alignment.CenterHorizontally
                                ) {
                                    Box(
                                        contentAlignment = Alignment.Center,
                                        modifier = Modifier.fillMaxWidth().height(140.dp)
                                    ) {
                                        if (lottiePath != null) {
                                            LottieVisualizer(
                                                path = lottiePath,
                                                modifier = Modifier.size(140.dp)
                                            )
                                        }
                                    }

                                    Spacer(Modifier.height(8.dp))

                                    Text(tituloEstado, fontWeight = FontWeight.Black, fontSize = 20.sp, color = if (esCancelado) Color.Red else colorTextoPrimario)
                                    Text(subTituloEstado, fontSize = 13.sp, color = colorTextoSecundario, textAlign = TextAlign.Center)

                                    Spacer(Modifier.height(16.dp))
                                    
                                    StepperYendo(progresoActual = progresoStepper, esPickup = esPickupReal, isDark = isDark)
                                }
                            }
                        }

                        // 🚀 MÓDULO DE PIN DE SEGURIDAD (ENTREGAS PROTEGIDAS)
                        val requierePin = pedido.requiresPin == true
                        val pinSeguridad = pedido.datosMandadito?.pinSeguridad

                        if (requierePin && !pinSeguridad.isNullOrBlank() && !esCancelado && pedido.estadoActual !in listOf("ENTREGADO", "CONCLUIDO")) {
                            Spacer(Modifier.height(16.dp))
                            Surface(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(horizontal = 24.dp),
                                color = RosaYendo.copy(alpha = 0.08f), // Fondo sutil
                                shape = RoundedCornerShape(16.dp),
                                border = BorderStroke(1.dp, RosaYendo.copy(alpha = 0.3f))
                            ) {
                                Column(
                                    modifier = Modifier.padding(16.dp),
                                    horizontalAlignment = Alignment.CenterHorizontally
                                ) {
                                    Row(verticalAlignment = Alignment.CenterVertically) {
                                        Icon(Icons.Default.Lock, contentDescription = "Seguridad", tint = RosaYendo, modifier = Modifier.size(16.dp))
                                        Spacer(Modifier.width(6.dp))
                                        Text(
                                            text = "PIN DE SEGURIDAD", 
                                            fontWeight = FontWeight.Black, 
                                            color = RosaYendo, 
                                            fontSize = 12.sp
                                        )
                                    }
                                    
                                    Spacer(Modifier.height(8.dp))
                                    
                                    // Texto del PIN gigante y espaciado
                                    Text(
                                        text = pinSeguridad,
                                        fontWeight = FontWeight.ExtraBold,
                                        fontSize = 38.sp,
                                        letterSpacing = 12.sp, // Mucho espacio entre números para fácil lectura
                                        color = colorTextoPrimario
                                    )
                                    
                                    Spacer(Modifier.height(6.dp))
                                    
                                    Text(
                                        text = "El repartidor pedirá este código al llegar. Compártelo con quien recibe el paquete.",
                                        fontSize = 11.sp,
                                        color = colorTextoSecundario,
                                        textAlign = TextAlign.Center,
                                        lineHeight = 14.sp
                                    )
                                }
                            }
                        }

                        // Compensación del offset negativo para que lo de abajo no choque
                        Spacer(Modifier.height(0.dp))

                        if (esComercio && pedido.estadoActual in listOf("SOLICITUD", "ARMANDO_PEDIDO")) {
                            Spacer(Modifier.height(16.dp))
                            Surface(modifier = Modifier.padding(horizontal = 24.dp), color = RosaYendo.copy(alpha = 0.1f), shape = RoundedCornerShape(8.dp)) {
                                Text("⚠️ El total final puede variar ligeramente debido al peso exacto.", modifier = Modifier.padding(12.dp), color = RosaYendo, fontSize = 11.sp, fontWeight = FontWeight.Bold, textAlign = TextAlign.Center)
                            }
                        }

                        // 🚀 TARJETA DEL REPARTIDOR (Estilo Uber/Rappi)
                        if (!esPickupReal && pedido.datosRepartidor != null) {
                            val datos = pedido.datosRepartidor
                            val nombre = datos["nombre"] ?: "Repartidor"
                            val foto = datos["foto_perfil"] ?: ""
                            val vehiculo = datos["vehiculo"] ?: "Vehículo"
                            val placas = datos["placas"] ?: ""
                            val telefono = datos["telefono"] ?: ""

                            Spacer(Modifier.height(16.dp))
                            Card(
                                modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                                colors = CardDefaults.cardColors(containerColor = colorSuperficie),
                                shape = RoundedCornerShape(16.dp),
                                elevation = CardDefaults.cardElevation(2.dp)
                            ) {
                                Row(
                                    modifier = Modifier.padding(16.dp),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    if (foto.isNotEmpty()) {
                                        AsyncImage(
                                            model = foto,
                                            contentDescription = "Foto de $nombre",
                                            modifier = Modifier.size(50.dp).clip(CircleShape),
                                            contentScale = ContentScale.Crop
                                        )
                                    } else {
                                        Box(
                                            modifier = Modifier.size(50.dp).clip(CircleShape).background(colorFondoBase),
                                            contentAlignment = Alignment.Center
                                        ) {
                                            Icon(Icons.Default.Person, null, tint = colorTextoSecundario)
                                        }
                                    }

                                    Spacer(Modifier.width(16.dp))

                                    Column(modifier = Modifier.weight(1f)) {
                                        Text(nombre, fontWeight = FontWeight.Bold, fontSize = 16.sp, color = colorTextoPrimario)
                                        Text("$vehiculo • $placas", fontSize = 12.sp, color = colorTextoSecundario)
                                    }

                                    if (telefono.isNotEmpty()) {
                                        val telLimpio = telefono.replace(Regex("[^0-9+]"), "")
                                        FilledTonalIconButton(
                                            onClick = { try { uriHandler.openUri("tel:$telLimpio") } catch (e: Exception) {} },
                                            colors = IconButtonDefaults.filledTonalIconButtonColors(containerColor = RosaYendo.copy(alpha = 0.1f))
                                        ) {
                                            Icon(Icons.Default.Phone, null, tint = RosaYendo)
                                        }
                                    }
                                }
                            }
                        }

                        Spacer(Modifier.height(24.dp))
                        Card(modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp), colors = CardDefaults.cardColors(containerColor = colorSuperficie), shape = RoundedCornerShape(16.dp)) {
                            Column(modifier = Modifier.padding(16.dp)) {
                                val totalOriginalEstimadoResumen = pedido.desgloseCliente.totalPagado
                                val totalNuevoAjustadoResumen = pedido.desgloseCliente.totalPagadoFinal 
                                    ?: pedido.desgloseCliente.totalPagadoFinalSnake
                                    ?: pedido.totalPagadoFinal
                                    ?: pedido.totalPagadoFinalSnake

                                val hayCambioTotalResumen = totalNuevoAjustadoResumen != null && kotlin.math.abs(totalNuevoAjustadoResumen - totalOriginalEstimadoResumen) > 0.01

                                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                                    Column(modifier = Modifier.weight(1f)) {
                                        Text("Resumen del pago", fontSize = 12.sp, color = colorTextoSecundario, fontWeight = FontWeight.Bold)
                                        Text(pedido.metodoPago, fontWeight = FontWeight.Bold, color = colorTextoPrimario)
                                    }
                                    Column(horizontalAlignment = Alignment.End) {
                                        if (hayCambioTotalResumen) {
                                            Text(
                                                text = "$${formatPrecio(totalOriginalEstimadoResumen)}",
                                                color = colorTextoSecundario,
                                                fontSize = 11.sp,
                                                textDecoration = androidx.compose.ui.text.style.TextDecoration.LineThrough
                                            )
                                            Text("$${formatPrecio(totalNuevoAjustadoResumen)}", fontWeight = FontWeight.Black, fontSize = 20.sp, color = RosaYendo)
                                        } else {
                                            Text(montoMuestra, fontWeight = FontWeight.Black, fontSize = 20.sp, color = RosaYendo)
                                        }
                                    }
                                }

                                Spacer(Modifier.height(12.dp))
                                HorizontalDivider(color = colorDivisor.copy(alpha = 0.5f))
                                Spacer(Modifier.height(12.dp))

                                // 🚀 DESGLOSE DETALLADO Y TRANSPARENTE LEYENDO DIRECTO DESDE FIRESTORE
                                val subtotalAjustadoResumen = pedido.desgloseCliente.subtotalProductosActual
                                val subtotalOriginalResumen = pedido.desgloseCliente.subtotalOriginalActual
                                    ?: subtotalAjustadoResumen

                                val hayCambioSubtotalResumen = hayCambioTotalResumen && kotlin.math.abs(subtotalAjustadoResumen - subtotalOriginalResumen) > 0.01

                                FilaDesgloseCostoComparativa(
                                    etiqueta = "Subtotal de productos",
                                    montoOriginal = if (hayCambioSubtotalResumen) subtotalOriginalResumen else null,
                                    montoNuevo = subtotalAjustadoResumen,
                                    colorEtiqueta = colorTextoSecundario,
                                    colorMonto = colorTextoPrimario
                                )
                                FilaDesgloseCostoComparativa(
                                    etiqueta = "Costo de envío",
                                    montoOriginal = null,
                                    montoNuevo = pedido.desgloseCliente.costoEnvio,
                                    colorEtiqueta = colorTextoSecundario,
                                    colorMonto = colorTextoPrimario
                                )
                                if (pedido.desgloseCliente.tarifaServicio > 0) {
                                    FilaDesgloseCostoComparativa(
                                        etiqueta = "Tarifa de servicio",
                                        montoOriginal = null,
                                        montoNuevo = pedido.desgloseCliente.tarifaServicio,
                                        colorEtiqueta = colorTextoSecundario,
                                        colorMonto = colorTextoPrimario
                                    )
                                }
                                if (pedido.desgloseCliente.propina > 0) {
                                    FilaDesgloseCostoComparativa(
                                        etiqueta = "Propina a repartidor",
                                        montoOriginal = null,
                                        montoNuevo = pedido.desgloseCliente.propina,
                                        colorEtiqueta = colorTextoSecundario,
                                        colorMonto = colorTextoPrimario
                                    )
                                }
                                if (pedido.desgloseCliente.descuentoCupon > 0) {
                                    FilaDesgloseCostoComparativa(
                                        etiqueta = "Descuento cupón",
                                        montoOriginal = null,
                                        montoNuevo = -pedido.desgloseCliente.descuentoCupon,
                                        colorEtiqueta = Color(0xFF00C853),
                                        colorMonto = Color(0xFF00C853)
                                    )
                                }

                                Spacer(Modifier.height(12.dp))
                                HorizontalDivider(color = colorDivisor.copy(alpha = 0.5f))
                                Spacer(Modifier.height(12.dp))

                                Text("Información de la orden", fontSize = 12.sp, color = colorTextoSecundario, fontWeight = FontWeight.Bold)
                                Row(modifier = Modifier.fillMaxWidth().padding(top = 4.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                                    Text("Orden #${pedido.idPedido.takeLast(6).uppercase()}", fontWeight = FontWeight.Bold, color = colorTextoPrimario, fontSize = 14.sp)
                                    
                                    if (puedeCancelar && !esCancelado) {
                                        TextButton(onClick = { mostrarDialogoCancelar = true }, contentPadding = PaddingValues(0.dp)) {
                                            Text("Cancelar pedido", color = Color.Red, fontWeight = FontWeight.Bold, fontSize = 14.sp)
                                        }
                                    }
                                }
                            }
                        }

                        Spacer(Modifier.height(16.dp))
                        Card(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(horizontal = 16.dp)
                                .clickable { mostrarDetallesCambios = true },
                            colors = CardDefaults.cardColors(containerColor = colorSuperficie),
                            shape = RoundedCornerShape(16.dp)
                        ) {
                            Row(
                                modifier = Modifier.padding(16.dp),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Icon(Icons.Default.ReceiptLong, null, tint = RosaYendo, modifier = Modifier.size(20.dp))
                                Spacer(Modifier.width(12.dp))
                                Text("Ver artículos", fontWeight = FontWeight.Bold, color = colorTextoPrimario)
                                Spacer(Modifier.weight(1f))
                                Icon(Icons.Default.ChevronRight, null, tint = colorTextoSecundario)
                            }
                        }
                        Spacer(Modifier.height(30.dp))
                    }

                    // 🚀 CHIPS FLOTANTES
                    Row(
                        modifier = Modifier
                            .statusBarsPadding()
                            .padding(16.dp)
                            .fillMaxWidth(),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(10.dp)
                    ) {
                        // Chip Atrás
                        Surface(
                            onClick = onBack,
                            shape = CircleShape,
                            color = RosaYendo,
                            modifier = Modifier.size(40.dp)
                        ) {
                            Box(contentAlignment = Alignment.Center) {
                                Icon(Icons.AutoMirrored.Filled.ArrowBack, null, tint = Color.White, modifier = Modifier.size(20.dp))
                            }
                        }

                        // 🚀 CHIP DE TIPO DE PEDIDO (Delivery / Pickup)
                        Surface(
                            shape = RoundedCornerShape(24.dp),
                            color = if (esPickupReal) Color(0xFF2196F3) else RosaYendo,
                            modifier = Modifier.height(40.dp)
                        ) {
                            Row(
                                modifier = Modifier.padding(horizontal = 16.dp),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Icon(
                                    if (esPickupReal) Icons.Default.ShoppingBag else Icons.Default.TwoWheeler,
                                    null, tint = Color.White, modifier = Modifier.size(16.dp)
                                )
                                Spacer(Modifier.width(8.dp))
                                Text(
                                    if (esPickupReal) "RECOGER EN TIENDA" else "ENTREGA A DOMICILIO",
                                    color = Color.White,
                                    fontWeight = FontWeight.ExtraBold,
                                    fontSize = 12.sp
                                )
                            }
                        }
                    }
                }
            }
        }

                // Lógica de cancelación
                if (mostrarDialogoCancelar) {
                    var isCanceling by remember { mutableStateOf(false) }
                    var motivoSeleccionado by remember { mutableStateOf("") }
                    var motivoPersonalizado by remember { mutableStateOf("") }
                    val focusRequester = remember { FocusRequester() }
                    val keyboardController = LocalSoftwareKeyboardController.current

                    val listaMotivos = if (pedido.estadoActual == "VALIDACION_CLIENTE") {
                        listOf(
                            "El incremento de precio por el peso real de la báscula es muy alto.",
                            "No estoy de acuerdo con los productos sustitutos elegidos por el tendero.",
                            "El comercio eliminó productos clave de mi lista por estar agotados.",
                            "El proceso de surtido tardó demasiado tiempo.",
                            "Otro motivo / Cambié de opinión."
                        )
                    } else {
                        listOf(
                            "Tiempo de espera muy largo",
                            "Me equivoqué en el pedido",
                            "Olvidé agregar un producto",
                            "Problemas con el pago",
                            "Ya no lo necesito",
                            "Otro (especifica)"
                        )
                    }

                    // 🚀 AUTO-FOCO AL SELECCIONAR OTRO
                    LaunchedEffect(motivoSeleccionado) {
                        if (motivoSeleccionado == "Otro (especifica)" || motivoSeleccionado == "Otro motivo / Cambié de opinión.") {
                            delay(200) // Pequeño delay para que la animación de visibilidad termine
                            focusRequester.requestFocus()
                            keyboardController?.show()
                        }
                    }

                    AlertDialog(
                        onDismissRequest = { if (!isCanceling) mostrarDialogoCancelar = false },
                        title = { Text("Cancelar pedido", fontWeight = FontWeight.Bold, fontSize = 20.sp, color = colorTextoPrimario) },
                        text = {
                            Column {
                                Text("Cuéntanos el motivo de tu cancelación:", fontSize = 15.sp, color = colorTextoPrimario)
                                Spacer(modifier = Modifier.height(8.dp))

                                LazyColumn(modifier = Modifier.heightIn(max = 340.dp)) {
                                    items(listaMotivos) { motivo ->
                                        val isSelected = motivoSeleccionado == motivo
                                        Row(
                                            modifier = Modifier
                                                .fillMaxWidth()
                                                .clickable { motivoSeleccionado = motivo }
                                                .padding(vertical = 4.dp),
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            RadioButton(
                                                selected = isSelected,
                                                onClick = { motivoSeleccionado = motivo },
                                                colors = RadioButtonDefaults.colors(selectedColor = RosaYendo, unselectedColor = colorTextoSecundario)
                                            )
                                            Spacer(modifier = Modifier.width(4.dp))
                                            Text(
                                                text = motivo,
                                                fontSize = 15.sp,
                                                fontWeight = if(isSelected) FontWeight.Bold else FontWeight.Normal,
                                                color = if(isSelected) colorTextoPrimario else colorTextoSecundario
                                            )
                                        }
                                    }

                                    item {
                                        val esOtro = motivoSeleccionado == "Otro (especifica)" || motivoSeleccionado == "Otro motivo / Cambié de opinión."
                                        AnimatedVisibility(visible = esOtro) {
                                            OutlinedTextField(
                                                value = motivoPersonalizado,
                                                onValueChange = { motivoPersonalizado = it },
                                                modifier = Modifier
                                                    .fillMaxWidth()
                                                    .padding(top = 4.dp, bottom = 8.dp)
                                                    .focusRequester(focusRequester), // 🚀 ASIGNAMOS EL FOCO
                                                placeholder = { Text("Escribe tu motivo aquí...", fontSize = 14.sp, color = colorTextoSecundario) },
                                                shape = RoundedCornerShape(12.dp),
                                                colors = OutlinedTextFieldDefaults.colors(
                                                    focusedBorderColor = RosaYendo,
                                                    unfocusedBorderColor = colorDivisor,
                                                    focusedTextColor = colorTextoPrimario,
                                                    unfocusedTextColor = colorTextoPrimario
                                                ),
                                                singleLine = false,
                                                maxLines = 3
                                            )
                                        }
                                    }
                                }
                            }
                        },
                        confirmButton = {
                            val esOtro = motivoSeleccionado == "Otro (especifica)" || motivoSeleccionado == "Otro motivo / Cambié de opinión."
                            val puedeConfirmar = if (esOtro) motivoPersonalizado.isNotBlank() else motivoSeleccionado.isNotEmpty()

                            Button(
                                onClick = {
                                    if (!isCanceling && puedeConfirmar) {
                                        isCanceling = true
                                        val motivoFinal = if (esOtro) motivoPersonalizado else motivoSeleccionado

                                        scope.launch {
                                            try {
                                                Firebase.firestore.collection("Pedidos").document(pedido.idPedido)
                                                    .update(
                                                        "estadoActual" to "CANCELADO",
                                                        "cancelado_por" to "CLIENTE",
                                                        "motivo_cancelacion" to motivoFinal,
                                                        "tiempos.cancelado" to getAhora()
                                                    )
                                                mostrarDialogoCancelar = false
                                            } catch (e: Exception) {
                                                isCanceling = false
                                            }
                                        }
                                    }
                                },
                                enabled = puedeConfirmar,
                                colors = ButtonDefaults.buttonColors(containerColor = Color.Red, disabledContainerColor = Color.Red.copy(0.4f)),
                                shape = RoundedCornerShape(12.dp)
                            ) {
                                if (isCanceling) {
                                    CircularProgressIndicator(modifier = Modifier.size(16.dp), color = Color.White, strokeWidth = 2.dp)
                                } else {
                                    Text("Cancelar pedido", color = Color.White, fontWeight = FontWeight.Bold, fontSize = 15.sp)
                                }
                            }
                        },
                        dismissButton = {
                            TextButton(onClick = { if (!isCanceling) mostrarDialogoCancelar = false }) {
                                Text("Volver", color = colorTextoSecundario, fontSize = 15.sp)
                            }
                        },
                        containerColor = colorSuperficie
                    )
                }

                if (mostrarChat) {
                    ChatBottomSheet(
                        idPedido = pedido.idPedido,
                        nombreContacto = nombreContacto,
                        fotoContacto = fotoContacto,
                        iconoContacto = iconoContacto,
                        onDismiss = { mostrarChat = false },
                        isDark = isDark,
                        mensajes = mensajes
                    )
                }

                if (mostrarDetallesCambios) {
                    DetalleCambiosBottomSheet(
                        pedido = pedido,
                        onDismiss = { mostrarDetallesCambios = false },
                        isDark = isDark,
                        colorTextoPrimario = colorTextoPrimario,
                        colorTextoSecundario = colorTextoSecundario,
                        colorSuperficie = colorSuperficie
                    )
                }

                if (mostrarDialogoCVVAjuste) {
                    AlertDialog(
                        onDismissRequest = { 
                            if (!procesandoAjusteSincrono) {
                                mostrarDialogoCVVAjuste = false
                                errorCVVAjuste = null
                            }
                        },
                        title = { Text("Autorizar Diferencia", color = colorTextoPrimario) },
                        text = {
                            Column {
                                Text("Por seguridad, ingresa el CVV para autorizar el cobro extra por los ajustes de peso.", fontSize = 14.sp, color = colorTextoSecundario, modifier = Modifier.padding(bottom = 12.dp))
                                
                                if (errorCVVAjuste != null) {
                                    Text(
                                        text = errorCVVAjuste!!,
                                        color = Color.Red,
                                        fontSize = 12.sp,
                                        fontWeight = FontWeight.Bold,
                                        modifier = Modifier.padding(bottom = 8.dp)
                                    )
                                }

                                OutlinedTextField(
                                    value = cvvAjusteInput,
                                    onValueChange = { 
                                        if(it.length <= 4 && it.all { char -> char.isDigit() }) {
                                            cvvAjusteInput = it 
                                            errorCVVAjuste = null
                                        }
                                    },
                                    label = { Text("CVV") },
                                    modifier = Modifier.fillMaxWidth(),
                                    keyboardOptions = androidx.compose.foundation.text.KeyboardOptions(keyboardType = androidx.compose.ui.text.input.KeyboardType.NumberPassword),
                                    colors = OutlinedTextFieldDefaults.colors(focusedBorderColor = RosaYendo, focusedTextColor = colorTextoPrimario, unfocusedTextColor = colorTextoPrimario),
                                    enabled = !procesandoAjusteSincrono
                                )
                            }
                        },
                        confirmButton = {
                            Button(
                                onClick = {
                                    procesandoAjusteSincrono = true
                                    errorCVVAjuste = null
                                    scope.launch {
                                        try {
                                            println("YENDO_LOG: Iniciando proceso de autorización de diferencia para pedido: ${pedido.idPedido}")
                                            
                                            val cardId = pedido.idTarjetaSeleccionada ?: ""
                                            if (cardId.isBlank()) {
                                                errorCVVAjuste = "No se detectó la tarjeta. Intenta de nuevo."
                                                procesandoAjusteSincrono = false
                                                return@launch
                                            }

                                            println("YENDO_LOG: Llamando a tokenización de Mercado Pago para CardID: $cardId")
                                            val nuevoToken = com.yendo.mx.repository.MercadoPagoRepository.generarTokenConTarjetaGuardada(cardId, cvvAjusteInput)
                                            
                                            if (nuevoToken != null) {
                                                println("YENDO_LOG: Token generado con éxito: $nuevoToken. Procediendo a actualizar Firestore.")
                                                
                                                try {
                                                    Firebase.firestore.collection("Pedidos").document(pedido.idPedido)
                                                        .update(
                                                            "nuevoTokenExtra" to nuevoToken,
                                                            "estadoActual" to "PROCESANDO_AJUSTE"
                                                        )
                                                    
                                                    val totalNuevo = pedido.desgloseCliente.totalPagadoFinal 
                                                        ?: pedido.desgloseCliente.totalPagadoFinalSnake
                                                        ?: pedido.totalPagadoFinal
                                                        ?: pedido.totalPagadoFinalSnake
                                                        ?: pedido.desgloseCliente.totalPagado

                                                    val exitoAjuste = com.yendo.mx.repository.PagosRepository.procesarAjusteYCapturaFinal(
                                                        idPedido = pedido.idPedido,
                                                        nuevoTotal = totalNuevo,
                                                        nuevoTokenExtra = nuevoToken
                                                    )

                                                    if (!exitoAjuste) {
                                                        Firebase.firestore.collection("Pedidos").document(pedido.idPedido)
                                                            .update(
                                                                "estadoActual" to "ERROR_COBRO_AJUSTE",
                                                                "motivoErrorExtra" to "Tarjeta o NIP declinado por el banco"
                                                            )
                                                        errorCVVAjuste = "NIP/CVV incorrecto o tarjeta rechazada. Revisa tus datos."
                                                    } else {
                                                        mostrarDialogoCVVAjuste = false
                                                        cvvAjusteInput = ""
                                                        errorCVVAjuste = null
                                                    }
                                                } catch (e: Exception) {
                                                    Firebase.firestore.collection("Pedidos").document(pedido.idPedido)
                                                        .update(
                                                            "estadoActual" to "ERROR_COBRO_AJUSTE",
                                                            "motivoErrorExtra" to (e.message ?: "Error al procesar pago")
                                                        )
                                                    errorCVVAjuste = "Error al procesar el pago: ${e.message}"
                                                    e.printStackTrace()
                                                }
                                            } else {
                                                Firebase.firestore.collection("Pedidos").document(pedido.idPedido)
                                                    .update(
                                                        "estadoActual" to "ERROR_COBRO_AJUSTE",
                                                        "motivoErrorExtra" to "CVV o NIP incorrecto"
                                                    )
                                                errorCVVAjuste = "CVV/NIP incorrecto o tarjeta rechazada. Revisa tus datos."
                                                cvvAjusteInput = ""
                                            }
                                        } catch (e: Exception) {
                                            errorCVVAjuste = "Error de conexión. Intenta de nuevo."
                                            e.printStackTrace()
                                        } finally {
                                            procesandoAjusteSincrono = false
                                        }
                                    }
                                },
                                colors = ButtonDefaults.buttonColors(containerColor = RosaYendo),
                                enabled = cvvAjusteInput.length >= 3 && !procesandoAjusteSincrono
                            ) {
                                if (procesandoAjusteSincrono) CircularProgressIndicator(color = Color.White, modifier = Modifier.size(20.dp), strokeWidth = 2.dp)
                                else Text("Confirmar", color = Color.White)
                            }
                        },
                        dismissButton = {
                            TextButton(onClick = { 
                                mostrarDialogoCVVAjuste = false 
                                errorCVVAjuste = null
                            }, enabled = !procesandoAjusteSincrono) {
                                Text("Cancelar", color = RosaYendo)
                            }
                        },
                        containerColor = colorSuperficie
                    )
                }
            }
        }

        // 🚀 OVERLAY DE CARGA BLOQUEANTE (PROCESANDO AJUSTE)
        if (pedido?.estadoActual == "PROCESANDO_AJUSTE") {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color.Black.copy(alpha = 0.8f))
                    .clickable(enabled = false) { /* Bloquea clics */ },
                contentAlignment = Alignment.Center
            ) {
                Column(horizontalAlignment = Alignment.CenterHorizontally, modifier = Modifier.padding(32.dp)) {
                    val composition by rememberLottieComposition {
                        LottieCompositionSpec.JsonString(Res.readBytes("files/yendo_cargando.json").decodeToString())
                    }
                    val painter = rememberLottiePainter(composition = composition, iterations = Compottie.IterateForever)
                    Image(painter = painter, contentDescription = "Cargando", modifier = Modifier.size(150.dp))
                    
                    Spacer(Modifier.height(24.dp))
                    
                    Text(
                        text = "Asegurando tus productos con el banco de forma segura...",
                        color = Color.White,
                        fontWeight = FontWeight.Bold,
                        fontSize = 16.sp,
                        textAlign = TextAlign.Center
                    )
                }
            }
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun DetalleCambiosBottomSheet(
    pedido: PedidoFirebase,
    onDismiss: () -> Unit,
    isDark: Boolean,
    colorTextoPrimario: Color,
    colorTextoSecundario: Color,
    colorSuperficie: Color
) {
    println("YENDO_LOG VALIDACION: Mostrando DetalleCambiosBottomSheet. Items: ${pedido.productos.size}")
    ModalBottomSheet(
        onDismissRequest = onDismiss,
        containerColor = colorSuperficie,
        shape = RoundedCornerShape(topStart = 24.dp, topEnd = 24.dp)
    ) {
        Column(modifier = Modifier.fillMaxWidth().padding(horizontal = 24.dp).padding(bottom = 32.dp)) {
            Text("Resumen de artículos", fontWeight = FontWeight.Black, fontSize = 20.sp, color = colorTextoPrimario)
            Spacer(Modifier.height(8.dp))
            Text("Detalle de los productos en tu orden.", fontSize = 14.sp, color = colorTextoSecundario)
            
            Spacer(Modifier.height(24.dp))
            
            LazyColumn(modifier = Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(16.dp)) {
                itemsIndexed(pedido.productos) { prodIndex, prod ->
                    // 🚀 OBTENER EL PRODUCTO ORIGINAL SOLICITADO EN CHECKOUT CON COMPARACIÓN FIEL POR ÍNDICE Y OPCIONES
                    val prodOriginal = pedido.productosSolicitados.getOrNull(prodIndex)?.takeIf { orig ->
                        ((orig.id.isNotBlank() && orig.id == prod.id) || (orig.nombre.isNotBlank() && orig.nombre == prod.nombre)) &&
                        orig.notas.trim() == prod.notas.trim() &&
                        orig.adicionales.map { "${it.nombre_grupo}:${it.nombre}:${it.precioExtra}" }.sorted() ==
                        prod.adicionales.map { "${it.nombre_grupo}:${it.nombre}:${it.precioExtra}" }.sorted()
                    } ?: pedido.productosSolicitados.firstOrNull { orig ->
                        ((orig.id.isNotBlank() && orig.id == prod.id) || (orig.nombre.isNotBlank() && orig.nombre == prod.nombre)) &&
                        orig.notas.trim() == prod.notas.trim() &&
                        orig.adicionales.map { "${it.nombre_grupo}:${it.nombre}:${it.precioExtra}" }.sorted() ==
                        prod.adicionales.map { "${it.nombre_grupo}:${it.nombre}:${it.precioExtra}" }.sorted()
                    } ?: pedido.productosSolicitados.firstOrNull { orig ->
                        (orig.id.isNotBlank() && orig.id == prod.id) || (orig.nombre.isNotBlank() && orig.nombre == prod.nombre)
                    }

                    val cantOriginal = prodOriginal?.cantidad ?: prod.cantidad
                    val huboAjustePeso = prod.pesoRealKg != null
                    val huboAjusteCantidad = prodOriginal != null && (prod.cantidad != prodOriginal.cantidad)

                    val esAgotado = prod.cantidad == 0.0 && (prod.pesoRealKg == null || prod.pesoRealKg == 0.0) && !prod.agregadoEnPicking
                    val tieneSustitutoReal = !prod.sustitutoDe.isNullOrBlank()

                    val colorFondoCelda = when {
                        esAgotado -> if (isDark) Color(0xFF2C2C2C) else Color(0xFFF5F5F5) // Gris apagado
                        tieneSustitutoReal -> if (isDark) Color(0xFF332B00) else Color(0xFFFFFDE7) // Amarillo sutil
                        prod.agregadoEnPicking -> if (isDark) Color(0xFF1B3320) else Color(0xFFE8F5E9) // Verde sutil
                        (huboAjustePeso || huboAjusteCantidad) -> if (isDark) Color(0xFF3A2312) else Color(0xFFFFF3E0) // Naranja sutil
                        else -> Color.Transparent
                    }

                    // 🚀 MODELO A: PRECIO BASE EN CABECERA ($300) + EXTRAS EN ADICIONALES (+$150) = TOTAL ($450)
                    val pesoOriginal = when (prod.tipoVenta) {
                        "PIEZA_POR_PESO" -> cantOriginal * (prodOriginal?.pesoEstimadoKg ?: prod.pesoEstimadoKg)
                        "PESO" -> if (cantOriginal > 0) cantOriginal else prod.pesoEstimadoKg
                        else -> cantOriginal
                    }
                    val extrasOriginal = (prodOriginal?.adicionales ?: prod.adicionales).sumOf { it.precioExtra } * cantOriginal
                    val subtotalOriginal = (pesoOriginal * (prodOriginal?.precioUnitario ?: prod.precioUnitario)) + extrasOriginal

                    val pesoReal = when (prod.tipoVenta) {
                        "PIEZA_POR_PESO" -> prod.pesoRealKg ?: (prod.cantidad * prod.pesoEstimadoKg)
                        "PESO" -> prod.pesoRealKg ?: prod.cantidad
                        else -> prod.cantidad
                    }
                    val extrasReal = prod.adicionales.sumOf { it.precioExtra } * prod.cantidad
                    val subtotalReal = (pesoReal * prod.precioUnitario) + extrasReal

                    val esModificado = (huboAjustePeso || huboAjusteCantidad || (kotlin.math.abs(subtotalReal - subtotalOriginal) > 0.01)) && !esAgotado && !prod.agregadoEnPicking

                    val colorItem = when {
                        esAgotado -> Color.Red
                        prod.agregadoEnPicking -> Color(0xFF2196F3) // Azul
                        esModificado -> Color(0xFFE65100) // Naranja (Ajustado)
                        else -> colorTextoPrimario
                    }

                    val colorSub = if (colorItem == colorTextoPrimario) colorTextoSecundario else colorItem.copy(alpha = 0.8f)

                    Surface(
                        modifier = Modifier.fillMaxWidth(),
                        color = colorFondoCelda,
                        shape = RoundedCornerShape(12.dp)
                    ) {
                        Column(modifier = Modifier.padding(12.dp)) {
                            // 🚀 BANNERS INFORMATIVOS SUPERIORES
                            if (tieneSustitutoReal && !esAgotado) {
                                Text(
                                    text = "Sustituye a: ${prod.sustitutoDe}",
                                    color = Color(0xFFFF9800),
                                    fontSize = 11.sp,
                                    fontWeight = FontWeight.Black,
                                    modifier = Modifier.padding(bottom = 6.dp)
                                )
                            } else if (prod.agregadoEnPicking && !esAgotado) {
                                Text(
                                    text = "Agregado extra por el comercio",
                                    color = Color(0xFF4CAF50),
                                    fontSize = 11.sp,
                                    fontWeight = FontWeight.Black,
                                    modifier = Modifier.padding(bottom = 6.dp)
                                )
                            } else if (huboAjusteCantidad && !esAgotado) {
                                Text(
                                    text = "Cantidad modificada por el comercio",
                                    color = Color(0xFFE65100),
                                    fontSize = 11.sp,
                                    fontWeight = FontWeight.Black,
                                    modifier = Modifier.padding(bottom = 6.dp)
                                )
                            }

                            val textoCantidad = when (prod.tipoVenta) {
                                "PIEZA_POR_PESO" -> {
                                    val piezasOrig = cantOriginal.toInt()
                                    val piezasNuevas = prod.cantidad.toInt()
                                    val txtPzas = if (piezasOrig != piezasNuevas) "$piezasOrig un. ➔ $piezasNuevas un." else "$piezasNuevas un."
                                    if (huboAjustePeso) {
                                        val pesoEst = cantOriginal * (prodOriginal?.pesoEstimadoKg ?: prod.pesoEstimadoKg)
                                        "$txtPzas (${formatPrecio(pesoEst)}kg ➔ ${prod.pesoRealKg}kg)"
                                    } else {
                                        "$txtPzas (${formatPrecio(prod.cantidad * prod.pesoEstimadoKg)}kg)"
                                    }
                                }
                                "PESO" -> {
                                    if (huboAjustePeso) {
                                        val original = if (cantOriginal > 0) cantOriginal else prod.pesoEstimadoKg
                                        "${formatPrecio(original)}kg ➔ ${formatPrecio(prod.pesoRealKg ?: 0.0)}kg"
                                    } else if (huboAjusteCantidad) {
                                        "${formatPrecio(cantOriginal)}kg ➔ ${formatPrecio(prod.cantidad)}kg"
                                    } else {
                                        "${formatPrecio(prod.cantidad)}kg"
                                    }
                                }
                                else -> {
                                    val cantOrigStr = if (cantOriginal % 1.0 == 0.0) "${cantOriginal.toInt()}" else formatPrecio(cantOriginal)
                                    val cantNuevaStr = if (prod.cantidad % 1.0 == 0.0) "${prod.cantidad.toInt()}" else formatPrecio(prod.cantidad)
                                    if (huboAjusteCantidad) {
                                        "$cantOrigStr un. ➔ $cantNuevaStr un."
                                    } else {
                                        "$cantNuevaStr un."
                                    }
                                }
                            }

                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Column(modifier = Modifier.weight(1f)) {
                                    Text(
                                        text = prod.nombre,
                                        fontWeight = FontWeight.Bold,
                                        fontSize = 14.sp,
                                        color = colorItem
                                    )
                                    Text(
                                        text = if (esAgotado) "No disponible en tienda" else textoCantidad,
                                        fontSize = 12.sp,
                                        color = colorSub
                                    )
                                }
                                
                                Column(horizontalAlignment = Alignment.End) {
                                    if (esModificado && subtotalOriginal > 0) {
                                        Text(
                                            text = "$${formatPrecio(subtotalOriginal)}",
                                            fontSize = 11.sp,
                                            color = colorTextoSecundario,
                                            textDecoration = androidx.compose.ui.text.style.TextDecoration.LineThrough
                                        )
                                    }
                                    
                                    if (esAgotado) {
                                        Text(
                                            text = "AGOTADO",
                                            color = Color.Red,
                                            fontSize = 12.sp,
                                            fontWeight = FontWeight.Bold,
                                            textDecoration = androidx.compose.ui.text.style.TextDecoration.LineThrough
                                        )
                                    } else {
                                        Text(
                                            text = "$${formatPrecio(subtotalReal)}",
                                            fontWeight = FontWeight.ExtraBold,
                                            fontSize = 15.sp,
                                            color = colorItem
                                        )
                                    }
                                }
                            }

                            // 🚀 RENDERIZADO DE ADICIONALES (EXTRAS / PERSONALIZACIÓN EN PEDIDO ACTIVO)
                            if (prod.adicionales.isNotEmpty()) {
                                Column(modifier = Modifier.padding(top = 6.dp)) {
                                    prod.adicionales.forEach { adic ->
                                        Row(
                                            modifier = Modifier.fillMaxWidth().padding(vertical = 1.dp),
                                            horizontalArrangement = Arrangement.SpaceBetween
                                        ) {
                                            Text(
                                                text = "+ ${adic.nombre}${if (adic.nombre_grupo.isNotBlank()) " (${adic.nombre_grupo})" else ""}",
                                                fontSize = 12.sp,
                                                color = if (isDark) Color.LightGray else Color.Black,
                                                fontWeight = FontWeight.Medium
                                            )
                                            if (adic.precioExtra > 0) {
                                                val totalExtraAdic = adic.precioExtra * prod.cantidad
                                                Text(
                                                    text = "+$${formatPrecio(totalExtraAdic)}",
                                                    fontSize = 12.sp,
                                                    color = RosaYendo,
                                                    fontWeight = FontWeight.Bold
                                                )
                                            }
                                        }
                                    }
                                }
                            }

                            // 🚀 RENDERIZADO DE NOTAS / INSTRUCCIONES ESPECIALES DEL CLIENTE
                            if (prod.notas.isNotBlank()) {
                                Surface(
                                    color = Color(0xFFFF9800).copy(alpha = 0.12f),
                                    shape = RoundedCornerShape(6.dp),
                                    modifier = Modifier.padding(top = 6.dp)
                                ) {
                                    Text(
                                        text = "📝 Nota: \"${prod.notas}\"",
                                        fontSize = 12.sp,
                                        color = Color(0xFFFF9800),
                                        fontWeight = FontWeight.Bold,
                                        modifier = Modifier.padding(horizontal = 8.dp, vertical = 4.dp)
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}



@OptIn(ExperimentalResourceApi::class)
@Composable
fun LottieVisualizer(path: String, modifier: Modifier = Modifier) {
    println("YENDO_LOG TRACKING: Lottie loading -> $path")
    // 🚀 CLAVE DE REACTIVIDAD: Al poner 'path' como key, forzamos la recarga si el estado cambia
    val composition by rememberLottieComposition(key = path) {
        LottieCompositionSpec.JsonString(Res.readBytes(path).decodeToString())
    }
    val painter = rememberLottiePainter(
        composition = composition,
        iterations = Compottie.IterateForever
    )
    Image(
        painter = painter,
        contentDescription = null,
        modifier = modifier
    )
}

@Composable
fun StepperYendo(progresoActual: Int, esPickup: Boolean, isDark: Boolean) {
    val colorInactivo = if (isDark) Color(0xFF333333) else Color(0xFFEEEEEE)
    val pasosTotales = if (esPickup) 3 else 5
    val progresoVisual = if (esPickup) when (progresoActual) { 1 -> 1; 2 -> 2; else -> 3 } else progresoActual

    val infiniteTransition = rememberInfiniteTransition(label = "stepper_anim")
    val offsetAnim by infiniteTransition.animateFloat(
        initialValue = -200f,
        targetValue = 600f,
        animationSpec = infiniteRepeatable(
            animation = tween(1500, easing = LinearEasing)
        ),
        label = "offset_gradient"
    )

    Row(modifier = Modifier.fillMaxWidth().padding(horizontal = 32.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
        for (i in 1..pasosTotales) {
            val isDone = i < progresoVisual
            val isActive = i == progresoVisual

            Box(
                modifier = Modifier
                    .size(if (isActive) 14.dp else 10.dp)
                    .clip(CircleShape)
                    .background(if (isDone || isActive) RosaYendo else colorInactivo),
                contentAlignment = Alignment.Center
            ) {
                if (isDone) Icon(Icons.Default.Check, null, tint = Color.White, modifier = Modifier.size(8.dp))
            }

            if (i < pasosTotales) {
                val lineIsDone = i < progresoVisual
                val lineIsLoading = i == progresoVisual && progresoVisual < pasosTotales

                Box(
                    modifier = Modifier
                        .weight(1f)
                        .height(3.dp)
                        .padding(horizontal = 4.dp)
                        .clip(RoundedCornerShape(50))
                        .background(if (lineIsDone) RosaYendo else colorInactivo)
                ) {
                    if (lineIsLoading) {
                        Canvas(modifier = Modifier.fillMaxSize()) {
                            val brush = Brush.linearGradient(
                                colors = listOf(
                                    RosaYendo.copy(alpha = 0.3f),
                                    RosaYendo,
                                    RosaYendo.copy(alpha = 0.3f)
                                ),
                                start = Offset(offsetAnim, 0f),
                                end = Offset(offsetAnim + 200f, 0f)
                            )
                            drawRect(brush = brush)
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun CalificarPedidoScreen(
    nombreRestaurante: String,
    logoRestaurante: String?,
    datosRepartidor: Map<String, String>?,
    aplicaRepartidor: Boolean,
    listaProductos: List<CartItemFirebase> = emptyList(),
    onEnviarCalificacion: (Int, String, Int?, String?) -> Unit
) {
    var ratingComercio by remember { mutableStateOf(0) }
    var comentarioComercio by remember { mutableStateOf("") }
    var ratingRepartidor by remember { mutableStateOf(0) }
    var comentarioRepartidor by remember { mutableStateOf("") }

    val isDark = isSystemInDarkTheme()
    val colorFondo = if (isDark) Color(0xFF121212) else Color.White
    val colorTexto = if (isDark) Color.White else Color.Black
    val colorSecundario = if (isDark) Color(0xFFAAAAAA) else Color.Gray

    val isFormularioValido = ratingComercio > 0 && (!aplicaRepartidor || ratingRepartidor > 0)

    Scaffold(
        containerColor = colorFondo,
        bottomBar = {
            Surface(shadowElevation = 8.dp, color = colorFondo) {
                Button(
                    onClick = {
                        val estrellasRep = if (aplicaRepartidor) ratingRepartidor else null
                        val comentRep = if (aplicaRepartidor) comentarioRepartidor else null
                        onEnviarCalificacion(ratingComercio, comentarioComercio, estrellasRep, comentRep)
                    },
                    enabled = isFormularioValido,
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(16.dp)
                        .height(56.dp),
                    shape = RoundedCornerShape(12.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = RosaYendo)
                ) {
                    Text("Enviar calificación", fontWeight = FontWeight.Bold)
                }
            }
        }
    ) { padding ->
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(padding)
                .verticalScroll(rememberScrollState())
                .padding(20.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text("¡Entregado!", fontWeight = FontWeight.Black, fontSize = 26.sp, color = colorTexto)
            Text("Esperamos que hayas disfrutado tu pedido", fontSize = 13.sp, color = colorSecundario)
            
            Spacer(Modifier.height(20.dp))

            // --- BLOQUE 1: EVALUACIÓN DEL COMERCIO ---
            Row(
                modifier = Modifier.fillMaxWidth().padding(vertical = 4.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                // 🚀 Miniatura del Logotipo del Comercio
                Box(
                    modifier = Modifier
                        .size(46.dp)
                        .clip(RoundedCornerShape(12.dp))
                        .background(Color.LightGray.copy(alpha = 0.3f))
                ) {
                    if (!logoRestaurante.isNullOrBlank()) {
                        AsyncImage(model = logoRestaurante, contentDescription = "Logo", contentScale = ContentScale.Crop)
                    } else {
                        Icon(Icons.Default.Storefront, null, modifier = Modifier.align(Alignment.Center), tint = Color.Gray)
                    }
                }

                Spacer(modifier = Modifier.width(12.dp))

                Column {
                    Text(
                        text = "¿Qué te pareció $nombreRestaurante?",
                        fontWeight = FontWeight.Bold,
                        fontSize = 14.sp,
                        color = colorTexto
                    )
                    Text(
                        text = "Califica los productos y la preparación",
                        color = Color.Gray,
                        fontSize = 11.sp
                    )
                }
            }
            
            RatingStars(
                rating = ratingComercio,
                onRatingChange = { ratingComercio = it },
                starSize = 30.dp,
                buttonSize = 38.dp
            )

            OutlinedTextField(
                value = comentarioComercio,
                onValueChange = { comentarioComercio = it },
                modifier = Modifier.fillMaxWidth(),
                placeholder = { Text("Escribe un comentario (opcional)", fontSize = 13.sp) },
                shape = RoundedCornerShape(12.dp),
                maxLines = 3,
                colors = OutlinedTextFieldDefaults.colors(
                    focusedTextColor = colorTexto,
                    unfocusedTextColor = colorTexto
                )
            )

            // --- BLOQUE 2: EVALUACIÓN LOGÍSTICA (Condicional) ---
            if (aplicaRepartidor) {
                val fotoRepartidor = datosRepartidor?.get("foto_perfil") ?: ""
                val nombreRep = datosRepartidor?.get("nombre") ?: "Repartidor"
                val vehiculoRepartidor = datosRepartidor?.get("vehiculo") ?: ""

                Spacer(modifier = Modifier.height(16.dp))
                HorizontalDivider(thickness = 0.5.dp, color = Color.LightGray.copy(alpha = 0.4f))
                Spacer(modifier = Modifier.height(16.dp))

                Row(
                    modifier = Modifier.fillMaxWidth().padding(vertical = 4.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    // 🚀 Foto de Perfil Circular del Repartidor
                    Box(
                        modifier = Modifier
                            .size(46.dp)
                            .clip(CircleShape)
                            .background(Color.LightGray.copy(alpha = 0.3f))
                    ) {
                        if (fotoRepartidor.isNotBlank()) {
                            AsyncImage(model = fotoRepartidor, contentDescription = "Repartidor", contentScale = ContentScale.Crop)
                        } else {
                            Icon(Icons.Default.Person, null, modifier = Modifier.align(Alignment.Center), tint = Color.Gray)
                        }
                    }

                    Spacer(modifier = Modifier.width(12.dp))

                    Column {
                        Text(
                            text = "¿Cómo fue tu entrega con $nombreRep?",
                            fontWeight = FontWeight.Bold,
                            fontSize = 14.sp,
                            color = colorTexto
                        )
                        if (vehiculoRepartidor.isNotBlank()) {
                            Text(
                                text = vehiculoRepartidor,
                                color = Color.Gray,
                                fontSize = 11.sp
                            )
                        }
                    }
                }

                RatingStars(
                    rating = ratingRepartidor,
                    onRatingChange = { ratingRepartidor = it },
                    starSize = 30.dp,
                    buttonSize = 38.dp
                )

                OutlinedTextField(
                    value = comentarioRepartidor,
                    onValueChange = { comentarioRepartidor = it },
                    modifier = Modifier.fillMaxWidth(),
                    placeholder = { Text("Escribe un comentario (opcional)", fontSize = 13.sp) },
                    shape = RoundedCornerShape(12.dp),
                    maxLines = 3,
                    colors = OutlinedTextFieldDefaults.colors(
                        focusedTextColor = colorTexto,
                        unfocusedTextColor = colorTexto
                    )
                )
            }

            // 🚀 BLOQUE 3: RESUMEN DE PRODUCTOS COMPRADOS (RECORDATORIO ABAJO DE LAS ESTRELLAS)
            if (listaProductos.isNotEmpty()) {
                Spacer(modifier = Modifier.height(20.dp))
                HorizontalDivider(thickness = 0.5.dp, color = Color.LightGray.copy(alpha = 0.4f))
                Spacer(modifier = Modifier.height(16.dp))

                Card(
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(16.dp),
                    colors = CardDefaults.cardColors(
                        containerColor = if (isDark) Color(0xFF1E1E1E) else Color(0xFFF5F5F7)
                    ),
                    border = BorderStroke(1.dp, if (isDark) Color(0xFF2C2C2E) else Color(0xFFE5E5EA))
                ) {
                    Column(modifier = Modifier.fillMaxWidth().padding(14.dp)) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            modifier = Modifier.padding(bottom = 8.dp)
                        ) {
                            Icon(
                                imageVector = Icons.Default.ShoppingBag,
                                contentDescription = null,
                                tint = RosaYendo,
                                modifier = Modifier.size(18.dp)
                            )
                            Spacer(Modifier.width(8.dp))
                            Text(
                                text = "Productos en tu pedido (${listaProductos.size})",
                                fontWeight = FontWeight.Bold,
                                fontSize = 13.sp,
                                color = colorTexto
                            )
                        }

                        HorizontalDivider(
                            thickness = 0.5.dp, 
                            color = if (isDark) Color(0xFF2C2C2E) else Color(0xFFE5E5EA)
                        )
                        Spacer(Modifier.height(8.dp))

                        listaProductos.forEachIndexed { index, item ->
                            val cantTexto = if (item.cantidad % 1.0 == 0.0) "${item.cantidad.toInt()}x" else "${item.cantidad}x"
                            Row(
                                modifier = Modifier.fillMaxWidth().padding(vertical = 3.dp),
                                verticalAlignment = Alignment.Top
                            ) {
                                Text(
                                    text = cantTexto,
                                    fontWeight = FontWeight.Bold,
                                    fontSize = 13.sp,
                                    color = RosaYendo,
                                    modifier = Modifier.width(32.dp)
                                )
                                Column(modifier = Modifier.weight(1f)) {
                                    Text(
                                        text = item.nombre,
                                        fontWeight = FontWeight.SemiBold,
                                        fontSize = 13.sp,
                                        color = colorTexto
                                    )
                                    if (item.adicionales.isNotEmpty()) {
                                        val extras = item.adicionales.joinToString(", ") { it.nombre }
                                        Text(
                                            text = extras,
                                            fontSize = 11.sp,
                                            color = colorSecundario
                                        )
                                    }
                                }
                                val pesoCalificar = when (item.tipoVenta) {
                                    "PIEZA_POR_PESO" -> item.pesoRealKg ?: (item.cantidad * item.pesoEstimadoKg)
                                    "PESO" -> item.pesoRealKg ?: item.cantidad
                                    else -> item.cantidad
                                }
                                val extrasCalificar = item.adicionales.sumOf { it.precioExtra } * item.cantidad
                                val subtotalCalificar = (pesoCalificar * item.precioUnitario) + extrasCalificar

                                if (subtotalCalificar > 0.0) {
                                    Text(
                                        text = "$${formatPrecio(subtotalCalificar)}",
                                        fontSize = 12.sp,
                                        fontWeight = FontWeight.Medium,
                                        color = colorSecundario
                                    )
                                }
                            }
                            if (index < listaProductos.size - 1) {
                                Spacer(Modifier.height(2.dp))
                            }
                        }
                    }
                }
            }
            
            Spacer(Modifier.height(30.dp))
        }
    }
}

@Composable
fun RatingStars(
    rating: Int, 
    onRatingChange: (Int) -> Unit,
    starSize: Dp = 30.dp,
    buttonSize: Dp = 38.dp
) {
    Row(modifier = Modifier.padding(vertical = 8.dp)) {
        (1..5).forEach { i ->
            IconButton(
                onClick = { onRatingChange(i) },
                modifier = Modifier.size(buttonSize)
            ) {
                Icon(
                    imageVector = if (i <= rating) Icons.Default.Star else Icons.Default.StarBorder,
                    contentDescription = null,
                    tint = Color(0xFFFFB300),
                    modifier = Modifier.size(starSize)
                )
            }
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ChatBottomSheet(idPedido: String, nombreContacto: String, fotoContacto: String?, iconoContacto: androidx.compose.ui.graphics.vector.ImageVector, onDismiss: () -> Unit, isDark: Boolean, mensajes: List<MensajeFirebase>) {
    var text by remember { mutableStateOf("") }
    val scope = rememberCoroutineScope()
    val listState = rememberLazyListState()
    var mensajesPendientes by remember { mutableStateOf<List<MensajeFirebase>>(emptyList()) }
    val sheetState = rememberModalBottomSheetState(skipPartiallyExpanded = true)
    val colorFondo = if (isDark) Color(0xFF1E1E1E) else Color.White
    val colorTexto = if (isDark) Color.White else Color.Black

    LaunchedEffect(mensajes.size) { if (mensajes.isNotEmpty()) listState.animateScrollToItem(mensajes.size - 1) }

    ModalBottomSheet(onDismissRequest = onDismiss, sheetState = sheetState, containerColor = colorFondo, contentWindowInsets = { WindowInsets(0,0,0,0) }) {
        Column(modifier = Modifier.fillMaxWidth().fillMaxHeight(0.9f).padding(horizontal = 20.dp).imePadding()) {
            Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.padding(vertical = 12.dp)) {
                if (fotoContacto != null) {
                    AsyncImage(
                        model = fotoContacto,
                        contentDescription = null,
                        modifier = Modifier.size(40.dp).clip(CircleShape),
                        contentScale = ContentScale.Crop
                    )
                } else {
                    Box(modifier = Modifier.size(40.dp).clip(CircleShape).background(Color.Gray.copy(0.2f)), contentAlignment = Alignment.Center) { Icon(iconoContacto, null, tint = RosaYendo) }
                }
                Spacer(Modifier.width(12.dp))
                Text(nombreContacto, fontWeight = FontWeight.ExtraBold, color = colorTexto)
            }
            HorizontalDivider()
            LazyColumn(modifier = Modifier.weight(1f).nestedScroll(object : NestedScrollConnection { override fun onPostScroll(consumed: Offset, available: Offset, source: NestedScrollSource): Offset = Offset(0f, available.y) }), state = listState, contentPadding = PaddingValues(vertical = 16.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {
                items(mensajes + mensajesPendientes) { msg -> BurbujaChat(msg.texto, msg.emisorId == "cliente", isDark, msg.timestamp, msg.estado) }
            }
            Row(modifier = Modifier.navigationBarsPadding().padding(bottom = 16.dp), verticalAlignment = Alignment.CenterVertically) {
                OutlinedTextField(value = text, onValueChange = { text = it }, modifier = Modifier.weight(1f), shape = RoundedCornerShape(24.dp), placeholder = { Text("Escribir...") }, colors = OutlinedTextFieldDefaults.colors(focusedTextColor = colorTexto, unfocusedTextColor = colorTexto))
                Spacer(Modifier.width(8.dp))
                IconButton(onClick = {
                    if (text.isNotBlank()) {
                        val txt = text; text = ""; val ts = getAhora()
                        val msg = MensajeFirebase("", txt, "cliente", ts, "ENVIANDO")
                        mensajesPendientes = mensajesPendientes + msg
                        scope.launch {
                            try {
                                val ref = Firebase.firestore.collection("Pedidos").document(idPedido).collection("Mensajes").document
                                ref.set(msg.copy(id = ref.id, estado = "ENVIADO"))
                                mensajesPendientes = mensajesPendientes - msg
                            } catch (e: Exception) { }
                        }
                    }
                }, modifier = Modifier.background(RosaYendo, CircleShape)) { Icon(Icons.AutoMirrored.Filled.Send, null, tint = Color.White) }
            }
        }
    }
}

@Composable
fun BurbujaChat(texto: String, soyYo: Boolean, isDark: Boolean, timestamp: Long, estado: String) {
    val colorBurbuja = if (soyYo) RosaYendo else (if (isDark) Color(0xFF2C2C2E) else Color(0xFFF5F5F5))
    val colorTexto = if (soyYo) Color.White else (if (isDark) Color.White else Color.Black)
    val colorHora = if (isDark) Color.LightGray else Color.Gray

    Box(modifier = Modifier.fillMaxWidth(), contentAlignment = if (soyYo) Alignment.CenterEnd else Alignment.CenterStart) {
        Column(horizontalAlignment = if (soyYo) Alignment.End else Alignment.Start) {
            Surface(shape = RoundedCornerShape(topStart = 16.dp, topEnd = 16.dp, bottomStart = if (soyYo) 16.dp else 4.dp, bottomEnd = if (soyYo) 4.dp else 16.dp), color = colorBurbuja) {
                Text(texto, modifier = Modifier.padding(horizontal = 16.dp, vertical = 10.dp), color = colorTexto, fontSize = 14.sp)
            }
            Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.padding(top = 2.dp)) {
                Text(formatoHora(timestamp), fontSize = 10.sp, color = colorHora)
                if (soyYo) {
                    Spacer(Modifier.width(4.dp))
                    Icon(if (estado == "ENVIANDO") Icons.Default.AccessTime else Icons.Default.DoneAll, null, modifier = Modifier.size(12.dp), tint = if (estado == "VISTO") Color.Blue else colorHora)
                }
            }
        }
    }
}

@Composable
private fun FilaDesgloseCostoComparativa(
    etiqueta: String,
    montoOriginal: Double?,
    montoNuevo: Double,
    colorEtiqueta: Color,
    colorMonto: Color
) {
    Row(
        modifier = Modifier.fillMaxWidth().padding(vertical = 3.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(etiqueta, color = colorEtiqueta, fontSize = 12.sp)
        Row(verticalAlignment = Alignment.CenterVertically) {
            if (montoOriginal != null && montoOriginal > 0.0 && kotlin.math.abs(montoOriginal - montoNuevo) > 0.01) {
                Text(
                    text = "$${formatPrecio(montoOriginal)}",
                    color = colorEtiqueta,
                    fontSize = 11.sp,
                    textDecoration = androidx.compose.ui.text.style.TextDecoration.LineThrough
                )
                Spacer(Modifier.width(4.dp))
                Text("➔", color = RosaYendo, fontSize = 11.sp, fontWeight = FontWeight.Bold)
                Spacer(Modifier.width(4.dp))
            }
            val textoMonto = if (montoNuevo < 0) "-$${formatPrecio(-montoNuevo)}" else "$${formatPrecio(montoNuevo)}"
            Text(textoMonto, fontSize = 12.sp, fontWeight = FontWeight.SemiBold, color = colorMonto)
        }
    }
}

/**
 * 🚀 HEURÍSTICA DE TIEMPO REAL (Haversine KMP)
 * Calcula la distancia entre negocio y entrega para sumarla al tiempo de cocina.
 */
private fun calcularETA(
    latNegocio: Double,
    lngNegocio: Double,
    latEntrega: Double,
    lngEntrega: Double,
    tiempoCocina: Int
): Int {
    val r = 6371.0 // Radio de la Tierra en km
    val dLat = (latEntrega - latNegocio) * PI / 180.0
    val dLon = (lngEntrega - lngNegocio) * PI / 180.0
    
    val a = sin(dLat / 2) * sin(dLat / 2) +
            cos(latNegocio * PI / 180.0) * cos(latEntrega * PI / 180.0) *
            sin(dLon / 2) * sin(dLon / 2)
    
    val c = 2 * atan2(sqrt(a), sqrt(1 - a))
    val distanciaKm = r * c

    // Heurística de tráfico: 3.5 min/km + 5 min de margen operativo
    val tiempoEnvio = (distanciaKm * 3.5).toInt() + 5
    return tiempoCocina + tiempoEnvio
}
